export const DiscipleshipJournalReadingPlanData = {
    months: [
        {
            monthNum: 1,
            monthName: "JANUARY",
            readings: [
                {
                    day: 1,
                    type: "gospels",
                    verse: "Matt 1:1-17"
                },
                {
                    day: 1,
                    type: "epistles",
                    verse: "Acts 1:1-11"
                },
                {
                    day: 1,
                    type: "wisdom",
                    verse: "Ps 1"
                },
                {
                    day: 1,
                    type: "law-and-prophets",
                    verse: "Gen 1-2"
                },
                {
                    day: 2,
                    type: "gospels",
                    verse: "Matt 1:18-25"
                },
                {
                    day: 2,
                    type: "epistles",
                    verse: "Acts 1:12-26"
                },
                {
                    day: 2,
                    type: "wisdom",
                    verse: "Ps 2"
                },
                {
                    day: 2,
                    type: "law-and-prophets",
                    verse: "Gen 3-4"
                },
                {
                    day: 3,
                    type: "gospels",
                    verse: "Matt 2:1-12"
                },
                {
                    day: 3,
                    type: "epistles",
                    verse: "Acts 2:1-21"
                },
                {
                    day: 3,
                    type: "wisdom",
                    verse: "Ps 3"
                },
                {
                    day: 3,
                    type: "law-and-prophets",
                    verse: "Gen 5-8"
                },
                {
                    day: 4,
                    type: "gospels",
                    verse: "Matt 2:13-23"
                },
                {
                    day: 4,
                    type: "epistles",
                    verse: "Acts 2:22-47"
                },
                {
                    day: 4,
                    type: "wisdom",
                    verse: "Ps 4"
                },
                {
                    day: 4,
                    type: "law-and-prophets",
                    verse: "Gen 9-11"
                },
                {
                    day: 5,
                    type: "gospels",
                    verse: "Matt 3:1-12"
                },
                {
                    day: 5,
                    type: "epistles",
                    verse: "Acts 3"
                },
                {
                    day: 5,
                    type: "wisdom",
                    verse: "Ps 5"
                },
                {
                    day: 5,
                    type: "law-and-prophets",
                    verse: "Gen 12-14"
                },
                {
                    day: 6,
                    type: "gospels",
                    verse: "Matt 3:13-17"
                },
                {
                    day: 6,
                    type: "epistles",
                    verse: "Acts 4:1-22"
                },
                {
                    day: 6,
                    type: "wisdom",
                    verse: "Ps 6"
                },
                {
                    day: 6,
                    type: "law-and-prophets",
                    verse: "Gen 15-17"
                },
                {
                    day: 7,
                    type: "gospels",
                    verse: "Matt 4:1-11"
                },
                {
                    day: 7,
                    type: "epistles",
                    verse: "Acts 4:23-37"
                },
                {
                    day: 7,
                    type: "wisdom",
                    verse: "Ps 7"
                },
                {
                    day: 7,
                    type: "law-and-prophets",
                    verse: "Gen 18-20"
                },
                {
                    day: 8,
                    type: "gospels",
                    verse: "Matt 4:12-17"
                },
                {
                    day: 8,
                    type: "epistles",
                    verse: "Acts 5:1-16"
                },
                {
                    day: 8,
                    type: "wisdom",
                    verse: "Ps 8"
                },
                {
                    day: 8,
                    type: "law-and-prophets",
                    verse: "Gen 21-23"
                },
                {
                    day: 9,
                    type: "gospels",
                    verse: "Matt 4:18-25"
                },
                {
                    day: 9,
                    type: "epistles",
                    verse: "Acts 5:17-42"
                },
                {
                    day: 9,
                    type: "wisdom",
                    verse: "Ps 9"
                },
                {
                    day: 9,
                    type: "law-and-prophets",
                    verse: "Gen 24"
                },
                {
                    day: 10,
                    type: "gospels",
                    verse: "Matt 5:1-12"
                },
                {
                    day: 10,
                    type: "epistles",
                    verse: "Acts 6"
                },
                {
                    day: 10,
                    type: "wisdom",
                    verse: "Ps 10"
                },
                {
                    day: 10,
                    type: "law-and-prophets",
                    verse: "Gen 25-26"
                },
                {
                    day: 11,
                    type: "gospels",
                    verse: "Matt 5:13-20"
                },
                {
                    day: 11,
                    type: "epistles",
                    verse: "Acts 7:1-38"
                },
                {
                    day: 11,
                    type: "wisdom",
                    verse: "Ps 11"
                },
                {
                    day: 11,
                    type: "law-and-prophets",
                    verse: "Gen 27-28"
                },
                {
                    day: 12,
                    type: "gospels",
                    verse: "Matt 5:21-32"
                },
                {
                    day: 12,
                    type: "epistles",
                    verse: "Acts 7:39-60"
                },
                {
                    day: 12,
                    type: "wisdom",
                    verse: "Ps 12"
                },
                {
                    day: 12,
                    type: "law-and-prophets",
                    verse: "Gen 29-30"
                },
                {
                    day: 13,
                    type: "gospels",
                    verse: "Matt 5:33-48"
                },
                {
                    day: 13,
                    type: "epistles",
                    verse: "Acts 8:1-25"
                },
                {
                    day: 13,
                    type: "wisdom",
                    verse: "Ps 13"
                },
                {
                    day: 13,
                    type: "law-and-prophets",
                    verse: "Gen 31"
                },
                {
                    day: 14,
                    type: "gospels",
                    verse: "Matt 6:1-15"
                },
                {
                    day: 14,
                    type: "epistles",
                    verse: "Acts 8:26-40"
                },
                {
                    day: 14,
                    type: "wisdom",
                    verse: "Ps 14"
                },
                {
                    day: 14,
                    type: "law-and-prophets",
                    verse: "Gen 32-33"
                },
                {
                    day: 15,
                    type: "gospels",
                    verse: "Matt 6:16-24"
                },
                {
                    day: 15,
                    type: "epistles",
                    verse: "Acts 9:1-19"
                },
                {
                    day: 15,
                    type: "wisdom",
                    verse: "Ps 15"
                },
                {
                    day: 15,
                    type: "law-and-prophets",
                    verse: "Gen 34-35"
                },
                {
                    day: 16,
                    type: "gospels",
                    verse: "Matt 6:25-34"
                },
                {
                    day: 16,
                    type: "epistles",
                    verse: "Acts 9:20-43"
                },
                {
                    day: 16,
                    type: "wisdom",
                    verse: "Ps 16"
                },
                {
                    day: 16,
                    type: "law-and-prophets",
                    verse: "Gen 36"
                },
                {
                    day: 17,
                    type: "gospels",
                    verse: "Matt 7:1-14"
                },
                {
                    day: 17,
                    type: "epistles",
                    verse: "Acts 10:1-23"
                },
                {
                    day: 17,
                    type: "wisdom",
                    verse: "Ps 17"
                },
                {
                    day: 17,
                    type: "law-and-prophets",
                    verse: "Gen 37-38"
                },
                {
                    day: 18,
                    type: "gospels",
                    verse: "Matt 7:15-29"
                },
                {
                    day: 18,
                    type: "epistles",
                    verse: "Acts 10:24-48"
                },
                {
                    day: 18,
                    type: "wisdom",
                    verse: "Ps 18:1-24"
                },
                {
                    day: 18,
                    type: "law-and-prophets",
                    verse: "Gen 39-40"
                },
                {
                    day: 19,
                    type: "gospels",
                    verse: "Matt 8:1-13"
                },
                {
                    day: 19,
                    type: "epistles",
                    verse: "Acts 11:1-18"
                },
                {
                    day: 19,
                    type: "wisdom",
                    verse: "Ps 18:25-50"
                },
                {
                    day: 19,
                    type: "law-and-prophets",
                    verse: "Gen 41"
                },
                {
                    day: 20,
                    type: "gospels",
                    verse: "Matt 8:14-22"
                },
                {
                    day: 20,
                    type: "epistles",
                    verse: "Acts 11:19-30"
                },
                {
                    day: 20,
                    type: "wisdom",
                    verse: "Ps 19"
                },
                {
                    day: 20,
                    type: "law-and-prophets",
                    verse: "Gen 42-43"
                },
                {
                    day: 21,
                    type: "gospels",
                    verse: "Matt 8:23-34"
                },
                {
                    day: 21,
                    type: "epistles",
                    verse: "Acts 12"
                },
                {
                    day: 21,
                    type: "wisdom",
                    verse: "Ps 20"
                },
                {
                    day: 21,
                    type: "law-and-prophets",
                    verse: "Gen 44-45"
                },
                {
                    day: 22,
                    type: "gospels",
                    verse: "Matt 9:1-13"
                },
                {
                    day: 22,
                    type: "epistles",
                    verse: "Acts 13:1-25"
                },
                {
                    day: 22,
                    type: "wisdom",
                    verse: "Ps 21"
                },
                {
                    day: 22,
                    type: "law-and-prophets",
                    verse: "Gen 46-47"
                },
                {
                    day: 23,
                    type: "gospels",
                    verse: "Matt 9:14-26"
                },
                {
                    day: 23,
                    type: "epistles",
                    verse: "Acts 13:26-52"
                },
                {
                    day: 23,
                    type: "wisdom",
                    verse: "Ps 22:1-11"
                },
                {
                    day: 23,
                    type: "law-and-prophets",
                    verse: "Gen 48"
                },
                {
                    day: 24,
                    type: "gospels",
                    verse: "Matt 9:27-38"
                },
                {
                    day: 24,
                    type: "epistles",
                    verse: "Acts 14"
                },
                {
                    day: 24,
                    type: "wisdom",
                    verse: "Ps 22:12-31"
                },
                {
                    day: 24,
                    type: "law-and-prophets",
                    verse: "Gen 49"
                },
                {
                    day: 25,
                    type: "gospels",
                    verse: "Matt 10:1-20"
                },
                {
                    day: 25,
                    type: "epistles",
                    verse: "Acts 15:1-21"
                },
                {
                    day: 25,
                    type: "wisdom",
                    verse: "Ps 23"
                },
                {
                    day: 25,
                    type: "law-and-prophets",
                    verse: "Gen 50"
                }
            ]
        },
        {
            monthNum: 2,
            monthName: "FEBRUARY",
            readings: [
                {
                    day: 1,
                    type: "gospels",
                    verse: "Matt 10:21-42"
                },
                {
                    day: 1,
                    type: "epistles",
                    verse: "Acts 15:22-41"
                },
                {
                    day: 1,
                    type: "wisdom",
                    verse: "Ps 24"
                },
                {
                    day: 1,
                    type: "law-and-prophets",
                    verse: "Exod 1-3"
                },
                {
                    day: 2,
                    type: "gospels",
                    verse: "Matt 11:1-19"
                },
                {
                    day: 2,
                    type: "epistles",
                    verse: "Acts 16:1-15"
                },
                {
                    day: 2,
                    type: "wisdom",
                    verse: "Ps 25"
                },
                {
                    day: 2,
                    type: "law-and-prophets",
                    verse: "Exod 4-6"
                },
                {
                    day: 3,
                    type: "gospels",
                    verse: "Matt 11:20-30"
                },
                {
                    day: 3,
                    type: "epistles",
                    verse: "Acts 16:16-40"
                },
                {
                    day: 3,
                    type: "wisdom",
                    verse: "Ps 26"
                },
                {
                    day: 3,
                    type: "law-and-prophets",
                    verse: "Exod 7-9"
                },
                {
                    day: 4,
                    type: "gospels",
                    verse: "Matt 12:1-21"
                },
                {
                    day: 4,
                    type: "epistles",
                    verse: "Acts 17:1-15"
                },
                {
                    day: 4,
                    type: "wisdom",
                    verse: "Ps 27"
                },
                {
                    day: 4,
                    type: "law-and-prophets",
                    verse: "Exod 10-12"
                },
                {
                    day: 5,
                    type: "gospels",
                    verse: "Matt 12:22-37"
                },
                {
                    day: 5,
                    type: "epistles",
                    verse: "Acts 17:16-34"
                },
                {
                    day: 5,
                    type: "wisdom",
                    verse: "Ps 28"
                },
                {
                    day: 5,
                    type: "law-and-prophets",
                    verse: "Exod 13-15"
                },
                {
                    day: 6,
                    type: "gospels",
                    verse: "Matt 12:38-50"
                },
                {
                    day: 6,
                    type: "epistles",
                    verse: "Acts 18:1-17"
                },
                {
                    day: 6,
                    type: "wisdom",
                    verse: "Ps 29"
                },
                {
                    day: 6,
                    type: "law-and-prophets",
                    verse: "Exod 16-18"
                },
                {
                    day: 7,
                    type: "gospels",
                    verse: "Matt 13:1-23"
                },
                {
                    day: 7,
                    type: "epistles",
                    verse: "Acts 18:18-28"
                },
                {
                    day: 7,
                    type: "wisdom",
                    verse: "Ps 30"
                },
                {
                    day: 7,
                    type: "law-and-prophets",
                    verse: "Exod 19-20"
                },
                {
                    day: 8,
                    type: "gospels",
                    verse: "Matt 13:24-43"
                },
                {
                    day: 8,
                    type: "epistles",
                    verse: "Acts 19:1-22"
                },
                {
                    day: 8,
                    type: "wisdom",
                    verse: "Ps 31"
                },
                {
                    day: 8,
                    type: "law-and-prophets",
                    verse: "Exod 21-23"
                },
                {
                    day: 9,
                    type: "gospels",
                    verse: "Matt 13:44-58"
                },
                {
                    day: 9,
                    type: "epistles",
                    verse: "Acts 19:23-41"
                },
                {
                    day: 9,
                    type: "wisdom",
                    verse: "Ps 32"
                },
                {
                    day: 9,
                    type: "law-and-prophets",
                    verse: "Exod 24-26"
                },
                {
                    day: 10,
                    type: "gospels",
                    verse: "Matt 14:1-21"
                },
                {
                    day: 10,
                    type: "epistles",
                    verse: "Acts 20:1-12"
                },
                {
                    day: 10,
                    type: "wisdom",
                    verse: "Ps 33"
                },
                {
                    day: 10,
                    type: "law-and-prophets",
                    verse: "Exod 27-29"
                },
                {
                    day: 11,
                    type: "gospels",
                    verse: "Matt 14:22-36"
                },
                {
                    day: 11,
                    type: "epistles",
                    verse: "Acts 20:13-38"
                },
                {
                    day: 11,
                    type: "wisdom",
                    verse: "Ps 34"
                },
                {
                    day: 11,
                    type: "law-and-prophets",
                    verse: "Exod 30-31"
                },
                {
                    day: 12,
                    type: "gospels",
                    verse: "Matt 15:1-20"
                },
                {
                    day: 12,
                    type: "epistles",
                    verse: "Acts 21:1-26"
                },
                {
                    day: 12,
                    type: "wisdom",
                    verse: "Ps 35"
                },
                {
                    day: 12,
                    type: "law-and-prophets",
                    verse: "Exod 32-33"
                },
                {
                    day: 13,
                    type: "gospels",
                    verse: "Matt 15:21-39"
                },
                {
                    day: 13,
                    type: "epistles",
                    verse: "Acts 21:27-40"
                },
                {
                    day: 13,
                    type: "wisdom",
                    verse: "Ps 36"
                },
                {
                    day: 13,
                    type: "law-and-prophets",
                    verse: "Exod 34"
                },
                {
                    day: 14,
                    type: "gospels",
                    verse: "Matt 16:1-12"
                },
                {
                    day: 14,
                    type: "epistles",
                    verse: "Acts 22"
                },
                {
                    day: 14,
                    type: "wisdom",
                    verse: "Ps 37:1-22"
                },
                {
                    day: 14,
                    type: "law-and-prophets",
                    verse: "Exod 35-37"
                },
                {
                    day: 15,
                    type: "gospels",
                    verse: "Matt 16:13-28"
                },
                {
                    day: 15,
                    type: "epistles",
                    verse: "Acts 23:1-11"
                },
                {
                    day: 15,
                    type: "wisdom",
                    verse: "Ps 37:23-40"
                },
                {
                    day: 15,
                    type: "law-and-prophets",
                    verse: "Exod 38-40"
                },
                {
                    day: 16,
                    type: "gospels",
                    verse: "Matt 17:1-13"
                },
                {
                    day: 16,
                    type: "epistles",
                    verse: "Acts 23:12-35"
                },
                {
                    day: 16,
                    type: "wisdom",
                    verse: "Ps 38"
                },
                {
                    day: 16,
                    type: "law-and-prophets",
                    verse: "Lev 1-4"
                },
                {
                    day: 17,
                    type: "gospels",
                    verse: "Matt 17:14-27"
                },
                {
                    day: 17,
                    type: "epistles",
                    verse: "Acts 24"
                },
                {
                    day: 17,
                    type: "wisdom",
                    verse: "Ps 39"
                },
                {
                    day: 17,
                    type: "law-and-prophets",
                    verse: "Lev 5-7"
                },
                {
                    day: 18,
                    type: "gospels",
                    verse: "Matt 18:1-14"
                },
                {
                    day: 18,
                    type: "epistles",
                    verse: "Acts 25:1-12"
                },
                {
                    day: 18,
                    type: "wisdom",
                    verse: "Ps 40"
                },
                {
                    day: 18,
                    type: "law-and-prophets",
                    verse: "Lev 8-10"
                },
                {
                    day: 19,
                    type: "gospels",
                    verse: "Matt 18:15-35"
                },
                {
                    day: 19,
                    type: "epistles",
                    verse: "Acts 25:13-27"
                },
                {
                    day: 19,
                    type: "wisdom",
                    verse: "Ps 41"
                },
                {
                    day: 19,
                    type: "law-and-prophets",
                    verse: "Lev 11-13"
                },
                {
                    day: 20,
                    type: "gospels",
                    verse: "Matt 19:1-15"
                },
                {
                    day: 20,
                    type: "epistles",
                    verse: "Acts 26:1-18"
                },
                {
                    day: 20,
                    type: "wisdom",
                    verse: "Ps 42"
                },
                {
                    day: 20,
                    type: "law-and-prophets",
                    verse: "Lev 14-15"
                },
                {
                    day: 21,
                    type: "gospels",
                    verse: "Matt 19:16-30"
                },
                {
                    day: 21,
                    type: "epistles",
                    verse: "Acts 26:19-32"
                },
                {
                    day: 21,
                    type: "wisdom",
                    verse: "Ps 43"
                },
                {
                    day: 21,
                    type: "law-and-prophets",
                    verse: "Lev 16-17"
                },
                {
                    day: 22,
                    type: "gospels",
                    verse: "Matt 20:1-16"
                },
                {
                    day: 22,
                    type: "epistles",
                    verse: "Acts 27:1-26"
                },
                {
                    day: 22,
                    type: "wisdom",
                    verse: "Ps 44"
                },
                {
                    day: 22,
                    type: "law-and-prophets",
                    verse: "Lev 18-20"
                },
                {
                    day: 23,
                    type: "gospels",
                    verse: "Matt 20:17-34"
                },
                {
                    day: 23,
                    type: "epistles",
                    verse: "Acts 27:27-44"
                },
                {
                    day: 23,
                    type: "wisdom",
                    verse: "Ps 45"
                },
                {
                    day: 23,
                    type: "law-and-prophets",
                    verse: "Lev 21-23"
                },
                {
                    day: 24,
                    type: "gospels",
                    verse: "Matt 21:1-11"
                },
                {
                    day: 24,
                    type: "epistles",
                    verse: "Acts 28:1-16"
                },
                {
                    day: 24,
                    type: "wisdom",
                    verse: "Ps 46"
                },
                {
                    day: 24,
                    type: "law-and-prophets",
                    verse: "Lev 24-25"
                },
                {
                    day: 25,
                    type: "gospels",
                    verse: "Matt 21:12-22"
                },
                {
                    day: 25,
                    type: "epistles",
                    verse: "Acts 28:17-31"
                },
                {
                    day: 25,
                    type: "wisdom",
                    verse: "Ps 47"
                },
                {
                    day: 25,
                    type: "law-and-prophets",
                    verse: "Lev 26-27"
                }
            ]
        },
        {
            monthNum: 3,
            monthName: "MARCH",
            readings: [
                {
                    day: 1,
                    type: "gospels",
                    verse: "Matt 21:23-32"
                },
                {
                    day: 1,
                    type: "epistles",
                    verse: "Rom 1:1-17"
                },
                {
                    day: 1,
                    type: "wisdom",
                    verse: "Ps 48"
                },
                {
                    day: 1,
                    type: "law-and-prophets",
                    verse: "Num 1-2"
                },
                {
                    day: 2,
                    type: "gospels",
                    verse: "Matt 21:33-46"
                },
                {
                    day: 2,
                    type: "epistles",
                    verse: "Rom 1:18-32"
                },
                {
                    day: 2,
                    type: "wisdom",
                    verse: "Ps 49"
                },
                {
                    day: 2,
                    type: "law-and-prophets",
                    verse: "Num 3-4"
                },
                {
                    day: 3,
                    type: "gospels",
                    verse: "Matt 22:1-14"
                },
                {
                    day: 3,
                    type: "epistles",
                    verse: "Rom 2"
                },
                {
                    day: 3,
                    type: "wisdom",
                    verse: "Ps 50"
                },
                {
                    day: 3,
                    type: "law-and-prophets",
                    verse: "Num 5-6"
                },
                {
                    day: 4,
                    type: "gospels",
                    verse: "Matt 22:15-33"
                },
                {
                    day: 4,
                    type: "epistles",
                    verse: "Rom 3"
                },
                {
                    day: 4,
                    type: "wisdom",
                    verse: "Ps 51"
                },
                {
                    day: 4,
                    type: "law-and-prophets",
                    verse: "Num 7-8"
                },
                {
                    day: 5,
                    type: "gospels",
                    verse: "Matt 22:34-46"
                },
                {
                    day: 5,
                    type: "epistles",
                    verse: "Rom 4"
                },
                {
                    day: 5,
                    type: "wisdom",
                    verse: "Ps 52"
                },
                {
                    day: 5,
                    type: "law-and-prophets",
                    verse: "Num 9-11"
                },
                {
                    day: 6,
                    type: "gospels",
                    verse: "Matt 23:1-12"
                },
                {
                    day: 6,
                    type: "epistles",
                    verse: "Rom 5:1-11"
                },
                {
                    day: 6,
                    type: "wisdom",
                    verse: "Ps 53"
                },
                {
                    day: 6,
                    type: "law-and-prophets",
                    verse: "Num 12-14"
                },
                {
                    day: 7,
                    type: "gospels",
                    verse: "Matt 23:13-24"
                },
                {
                    day: 7,
                    type: "epistles",
                    verse: "Rom 5:12-21"
                },
                {
                    day: 7,
                    type: "wisdom",
                    verse: "Ps 54"
                },
                {
                    day: 7,
                    type: "law-and-prophets",
                    verse: "Num 15-17"
                },
                {
                    day: 8,
                    type: "gospels",
                    verse: "Matt 23:25-39"
                },
                {
                    day: 8,
                    type: "epistles",
                    verse: "Rom 6:1-14"
                },
                {
                    day: 8,
                    type: "wisdom",
                    verse: "Ps 55"
                },
                {
                    day: 8,
                    type: "law-and-prophets",
                    verse: "Num 18-20"
                },
                {
                    day: 9,
                    type: "gospels",
                    verse: "Matt 24:1-14"
                },
                {
                    day: 9,
                    type: "epistles",
                    verse: "Rom 6:15-23"
                },
                {
                    day: 9,
                    type: "wisdom",
                    verse: "Ps 56"
                },
                {
                    day: 9,
                    type: "law-and-prophets",
                    verse: "Num 21-22"
                },
                {
                    day: 10,
                    type: "gospels",
                    verse: "Matt 24:15-35"
                },
                {
                    day: 10,
                    type: "epistles",
                    verse: "Rom 7:1-12"
                },
                {
                    day: 10,
                    type: "wisdom",
                    verse: "Ps 57"
                },
                {
                    day: 10,
                    type: "law-and-prophets",
                    verse: "Num 23-25"
                },
                {
                    day: 11,
                    type: "gospels",
                    verse: "Matt 24:36-51"
                },
                {
                    day: 11,
                    type: "epistles",
                    verse: "Rom 7:13-25"
                },
                {
                    day: 11,
                    type: "wisdom",
                    verse: "Ps 58"
                },
                {
                    day: 11,
                    type: "law-and-prophets",
                    verse: "Num 26-27"
                },
                {
                    day: 12,
                    type: "gospels",
                    verse: "Matt 25:1-13"
                },
                {
                    day: 12,
                    type: "epistles",
                    verse: "Rom 8:1-17"
                },
                {
                    day: 12,
                    type: "wisdom",
                    verse: "Ps 59"
                },
                {
                    day: 12,
                    type: "law-and-prophets",
                    verse: "Num 28-30"
                },
                {
                    day: 13,
                    type: "gospels",
                    verse: "Matt 25:14-30"
                },
                {
                    day: 13,
                    type: "epistles",
                    verse: "Rom 8:18-39"
                },
                {
                    day: 13,
                    type: "wisdom",
                    verse: "Ps 60"
                },
                {
                    day: 13,
                    type: "law-and-prophets",
                    verse: "Num 31-32"
                },
                {
                    day: 14,
                    type: "gospels",
                    verse: "Matt 25:31-46"
                },
                {
                    day: 14,
                    type: "epistles",
                    verse: "Rom 9:1-18"
                },
                {
                    day: 14,
                    type: "wisdom",
                    verse: "Ps 61"
                },
                {
                    day: 14,
                    type: "law-and-prophets",
                    verse: "Num 33-36"
                },
                {
                    day: 15,
                    type: "gospels",
                    verse: "Matt 26:1-16"
                },
                {
                    day: 15,
                    type: "epistles",
                    verse: "Rom 9:19-33"
                },
                {
                    day: 15,
                    type: "wisdom",
                    verse: "Ps 62"
                },
                {
                    day: 15,
                    type: "law-and-prophets",
                    verse: "Deut 1-3"
                },
                {
                    day: 16,
                    type: "gospels",
                    verse: "Matt 26:17-35"
                },
                {
                    day: 16,
                    type: "epistles",
                    verse: "Rom 10"
                },
                {
                    day: 16,
                    type: "wisdom",
                    verse: "Ps 63"
                },
                {
                    day: 16,
                    type: "law-and-prophets",
                    verse: "Deut 4-5"
                },
                {
                    day: 17,
                    type: "gospels",
                    verse: "Matt 26:36-56"
                },
                {
                    day: 17,
                    type: "epistles",
                    verse: "Rom 11:1-24"
                },
                {
                    day: 17,
                    type: "wisdom",
                    verse: "Ps 64"
                },
                {
                    day: 17,
                    type: "law-and-prophets",
                    verse: "Deut 6-8"
                },
                {
                    day: 18,
                    type: "gospels",
                    verse: "Matt 26:57-75"
                },
                {
                    day: 18,
                    type: "epistles",
                    verse: "Rom 11:25-36"
                },
                {
                    day: 18,
                    type: "wisdom",
                    verse: "Ps 65"
                },
                {
                    day: 18,
                    type: "law-and-prophets",
                    verse: "Deut 9-12"
                },
                {
                    day: 19,
                    type: "gospels",
                    verse: "Matt 27:1-10"
                },
                {
                    day: 19,
                    type: "epistles",
                    verse: "Rom 12:1-8"
                },
                {
                    day: 19,
                    type: "wisdom",
                    verse: "Ps 66"
                },
                {
                    day: 19,
                    type: "law-and-prophets",
                    verse: "Deut 13-17"
                },
                {
                    day: 20,
                    type: "gospels",
                    verse: "Matt 27:11-26"
                },
                {
                    day: 20,
                    type: "epistles",
                    verse: "Rom 12:9-21"
                },
                {
                    day: 20,
                    type: "wisdom",
                    verse: "Ps 67"
                },
                {
                    day: 20,
                    type: "law-and-prophets",
                    verse: "Deut 18-21"
                },
                {
                    day: 21,
                    type: "gospels",
                    verse: "Matt 27:27-44"
                },
                {
                    day: 21,
                    type: "epistles",
                    verse: "Rom 13"
                },
                {
                    day: 21,
                    type: "wisdom",
                    verse: "Ps 68"
                },
                {
                    day: 21,
                    type: "law-and-prophets",
                    verse: "Deut 22-26"
                },
                {
                    day: 22,
                    type: "gospels",
                    verse: "Matt 27:45-56"
                },
                {
                    day: 22,
                    type: "epistles",
                    verse: "Rom 14"
                },
                {
                    day: 22,
                    type: "wisdom",
                    verse: "Ps 69:1-18"
                },
                {
                    day: 22,
                    type: "law-and-prophets",
                    verse: "Deut 27-28"
                },
                {
                    day: 23,
                    type: "gospels",
                    verse: "Matt 27:57-66"
                },
                {
                    day: 23,
                    type: "epistles",
                    verse: "Rom 15:1-13"
                },
                {
                    day: 23,
                    type: "wisdom",
                    verse: "Ps 69:19-36"
                },
                {
                    day: 23,
                    type: "law-and-prophets",
                    verse: "Deut 29-31"
                },
                {
                    day: 24,
                    type: "gospels",
                    verse: "Matt 28:1-10"
                },
                {
                    day: 24,
                    type: "epistles",
                    verse: "Rom 15:14-33"
                },
                {
                    day: 24,
                    type: "wisdom",
                    verse: "Ps 70"
                },
                {
                    day: 24,
                    type: "law-and-prophets",
                    verse: "Deut 32"
                },
                {
                    day: 25,
                    type: "gospels",
                    verse: "Matt 28:11-20"
                },
                {
                    day: 25,
                    type: "epistles",
                    verse: "Rom 16"
                },
                {
                    day: 25,
                    type: "wisdom",
                    verse: "Ps 71"
                },
                {
                    day: 25,
                    type: "law-and-prophets",
                    verse: "Deut 33-34"
                }
            ]
        },
        {
            monthNum: 4,
            monthName: "APRIL",
            readings: [
                {
                    day: 1,
                    type: "gospels",
                    verse: "Mark 1:1-8"
                },
                {
                    day: 1,
                    type: "epistles",
                    verse: "1Cor 1:1-17"
                },
                {
                    day: 1,
                    type: "wisdom",
                    verse: "Ps 72"
                },
                {
                    day: 1,
                    type: "law-and-prophets",
                    verse: "Josh 1-2"
                },
                {
                    day: 2,
                    type: "gospels",
                    verse: "Mark 1:9-20"
                },
                {
                    day: 2,
                    type: "epistles",
                    verse: "1Cor 1:18-31"
                },
                {
                    day: 2,
                    type: "wisdom",
                    verse: "Ps 73"
                },
                {
                    day: 2,
                    type: "law-and-prophets",
                    verse: "Josh 3-5"
                },
                {
                    day: 3,
                    type: "gospels",
                    verse: "Mark 1:21-34"
                },
                {
                    day: 3,
                    type: "epistles",
                    verse: "1Cor 2"
                },
                {
                    day: 3,
                    type: "wisdom",
                    verse: "Ps 74"
                },
                {
                    day: 3,
                    type: "law-and-prophets",
                    verse: "Josh 6-7"
                },
                {
                    day: 4,
                    type: "gospels",
                    verse: "Mark 1:35-45"
                },
                {
                    day: 4,
                    type: "epistles",
                    verse: "1Cor 3"
                },
                {
                    day: 4,
                    type: "wisdom",
                    verse: "Ps 75"
                },
                {
                    day: 4,
                    type: "law-and-prophets",
                    verse: "Josh 8-9"
                },
                {
                    day: 5,
                    type: "gospels",
                    verse: "Mark 2:1-12"
                },
                {
                    day: 5,
                    type: "epistles",
                    verse: "1Cor 4"
                },
                {
                    day: 5,
                    type: "wisdom",
                    verse: "Ps 76"
                },
                {
                    day: 5,
                    type: "law-and-prophets",
                    verse: "Josh 10-12"
                },
                {
                    day: 6,
                    type: "gospels",
                    verse: "Mark 2:13-17"
                },
                {
                    day: 6,
                    type: "epistles",
                    verse: "1Cor 5"
                },
                {
                    day: 6,
                    type: "wisdom",
                    verse: "Ps 77"
                },
                {
                    day: 6,
                    type: "law-and-prophets",
                    verse: "Josh 13-14"
                },
                {
                    day: 7,
                    type: "gospels",
                    verse: "Mark 2:18-28"
                },
                {
                    day: 7,
                    type: "epistles",
                    verse: "1Cor 6:1-11"
                },
                {
                    day: 7,
                    type: "wisdom",
                    verse: "Ps 78:1-39"
                },
                {
                    day: 7,
                    type: "law-and-prophets",
                    verse: "Josh 15-17"
                },
                {
                    day: 8,
                    type: "gospels",
                    verse: "Mark 3:1-19"
                },
                {
                    day: 8,
                    type: "epistles",
                    verse: "1Cor 6:12-20"
                },
                {
                    day: 8,
                    type: "wisdom",
                    verse: "Ps 78:40-72"
                },
                {
                    day: 8,
                    type: "law-and-prophets",
                    verse: "Josh 18-19"
                },
                {
                    day: 9,
                    type: "gospels",
                    verse: "Mark 3:20-35"
                },
                {
                    day: 9,
                    type: "epistles",
                    verse: "1Cor 7:1-16"
                },
                {
                    day: 9,
                    type: "wisdom",
                    verse: "Ps 79"
                },
                {
                    day: 9,
                    type: "law-and-prophets",
                    verse: "Josh 20-21"
                },
                {
                    day: 10,
                    type: "gospels",
                    verse: "Mark 4:1-20"
                },
                {
                    day: 10,
                    type: "epistles",
                    verse: "1Cor 7:17-40"
                },
                {
                    day: 10,
                    type: "wisdom",
                    verse: "Ps 80"
                },
                {
                    day: 10,
                    type: "law-and-prophets",
                    verse: "Josh 22-23"
                },
                {
                    day: 11,
                    type: "gospels",
                    verse: "Mark 4:21-41"
                },
                {
                    day: 11,
                    type: "epistles",
                    verse: "1Cor 8"
                },
                {
                    day: 11,
                    type: "wisdom",
                    verse: "Ps 81"
                },
                {
                    day: 11,
                    type: "law-and-prophets",
                    verse: "Josh 24"
                },
                {
                    day: 12,
                    type: "gospels",
                    verse: "Mark 5:1-20"
                },
                {
                    day: 12,
                    type: "epistles",
                    verse: "1Cor 9:1-12"
                },
                {
                    day: 12,
                    type: "wisdom",
                    verse: "Ps 82"
                },
                {
                    day: 12,
                    type: "law-and-prophets",
                    verse: "Judg 1-3"
                },
                {
                    day: 13,
                    type: "gospels",
                    verse: "Mark 5:21-43"
                },
                {
                    day: 13,
                    type: "epistles",
                    verse: "1Cor 9:13-27"
                },
                {
                    day: 13,
                    type: "wisdom",
                    verse: "Ps 83"
                },
                {
                    day: 13,
                    type: "law-and-prophets",
                    verse: "Judg 4-5"
                },
                {
                    day: 14,
                    type: "gospels",
                    verse: "Mark 6:1-13"
                },
                {
                    day: 14,
                    type: "epistles",
                    verse: "1Cor 10:1-13"
                },
                {
                    day: 14,
                    type: "wisdom",
                    verse: "Ps 84"
                },
                {
                    day: 14,
                    type: "law-and-prophets",
                    verse: "Judg 6-7"
                },
                {
                    day: 15,
                    type: "gospels",
                    verse: "Mark 6:14-29"
                },
                {
                    day: 15,
                    type: "epistles",
                    verse: "1Cor 10:14-33"
                },
                {
                    day: 15,
                    type: "wisdom",
                    verse: "Ps 85"
                },
                {
                    day: 15,
                    type: "law-and-prophets",
                    verse: "Judg 8"
                },
                {
                    day: 16,
                    type: "gospels",
                    verse: "Mark 6:30-44"
                },
                {
                    day: 16,
                    type: "epistles",
                    verse: "1Cor 11:1-16"
                },
                {
                    day: 16,
                    type: "wisdom",
                    verse: "Ps 86"
                },
                {
                    day: 16,
                    type: "law-and-prophets",
                    verse: "Judg 9"
                },
                {
                    day: 17,
                    type: "gospels",
                    verse: "Mark 6:45-56"
                },
                {
                    day: 17,
                    type: "epistles",
                    verse: "1Cor 11:17-34"
                },
                {
                    day: 17,
                    type: "wisdom",
                    verse: "Ps 87"
                },
                {
                    day: 17,
                    type: "law-and-prophets",
                    verse: "Judg 10-12"
                },
                {
                    day: 18,
                    type: "gospels",
                    verse: "Mark 7:1-23"
                },
                {
                    day: 18,
                    type: "epistles",
                    verse: "1Cor 12:1-13"
                },
                {
                    day: 18,
                    type: "wisdom",
                    verse: "Ps 88"
                },
                {
                    day: 18,
                    type: "law-and-prophets",
                    verse: "Judg 13-15"
                },
                {
                    day: 19,
                    type: "gospels",
                    verse: "Mark 7:24-37"
                },
                {
                    day: 19,
                    type: "epistles",
                    verse: "1Cor 12:14-31"
                },
                {
                    day: 19,
                    type: "wisdom",
                    verse: "Ps 89:1-18"
                },
                {
                    day: 19,
                    type: "law-and-prophets",
                    verse: "Judg 16"
                },
                {
                    day: 20,
                    type: "gospels",
                    verse: "Mark 8:1-13"
                },
                {
                    day: 20,
                    type: "epistles",
                    verse: "1Cor 13"
                },
                {
                    day: 20,
                    type: "wisdom",
                    verse: "Ps 89:19-52"
                },
                {
                    day: 20,
                    type: "law-and-prophets",
                    verse: "Judg 17-18"
                },
                {
                    day: 21,
                    type: "gospels",
                    verse: "Mark 8:14-21"
                },
                {
                    day: 21,
                    type: "epistles",
                    verse: "1Cor 14:1-25"
                },
                {
                    day: 21,
                    type: "wisdom",
                    verse: "Ps 90"
                },
                {
                    day: 21,
                    type: "law-and-prophets",
                    verse: "Judg 19"
                },
                {
                    day: 22,
                    type: "gospels",
                    verse: "Mark 8:22-30"
                },
                {
                    day: 22,
                    type: "epistles",
                    verse: "1Cor 14:26-40"
                },
                {
                    day: 22,
                    type: "wisdom",
                    verse: "Ps 91"
                },
                {
                    day: 22,
                    type: "law-and-prophets",
                    verse: "Judg 20-21"
                },
                {
                    day: 23,
                    type: "gospels",
                    verse: "Mark 8:31-38"
                },
                {
                    day: 23,
                    type: "epistles",
                    verse: "1Cor 15:1-28"
                },
                {
                    day: 23,
                    type: "wisdom",
                    verse: "Ps 92"
                },
                {
                    day: 23,
                    type: "law-and-prophets",
                    verse: "Ruth 1"
                },
                {
                    day: 24,
                    type: "gospels",
                    verse: "Mark 9:1-13"
                },
                {
                    day: 24,
                    type: "epistles",
                    verse: "1Cor 15:29-58"
                },
                {
                    day: 24,
                    type: "wisdom",
                    verse: "Ps 93"
                },
                {
                    day: 24,
                    type: "law-and-prophets",
                    verse: "Ruth 2-3"
                },
                {
                    day: 25,
                    type: "gospels",
                    verse: "Mark 9:14-32"
                },
                {
                    day: 25,
                    type: "epistles",
                    verse: "1Cor 16"
                },
                {
                    day: 25,
                    type: "wisdom",
                    verse: "Ps 94"
                },
                {
                    day: 25,
                    type: "law-and-prophets",
                    verse: "Ruth 4"
                }
            ]
        },
        {
            monthNum: 5,
            monthName: "MAY",
            readings: [
                {
                    day: 1,
                    type: "gospels",
                    verse: "Mark 9:33-50"
                },
                {
                    day: 1,
                    type: "epistles",
                    verse: "2Cor 1:1-11"
                },
                {
                    day: 1,
                    type: "wisdom",
                    verse: "Ps 95"
                },
                {
                    day: 1,
                    type: "law-and-prophets",
                    verse: "1Sam 1-2"
                },
                {
                    day: 2,
                    type: "gospels",
                    verse: "Mark 10:1-16"
                },
                {
                    day: 2,
                    type: "epistles",
                    verse: "2Cor 1:12-24"
                },
                {
                    day: 2,
                    type: "wisdom",
                    verse: "Ps 96"
                },
                {
                    day: 2,
                    type: "law-and-prophets",
                    verse: "1Sam 3-5"
                },
                {
                    day: 3,
                    type: "gospels",
                    verse: "Mark 10:17-34"
                },
                {
                    day: 3,
                    type: "epistles",
                    verse: "2Cor 2"
                },
                {
                    day: 3,
                    type: "wisdom",
                    verse: "Ps 97"
                },
                {
                    day: 3,
                    type: "law-and-prophets",
                    verse: "1Sam 6-8"
                },
                {
                    day: 4,
                    type: "gospels",
                    verse: "Mark 10:35-52"
                },
                {
                    day: 4,
                    type: "epistles",
                    verse: "2Cor 3"
                },
                {
                    day: 4,
                    type: "wisdom",
                    verse: "Ps 98"
                },
                {
                    day: 4,
                    type: "law-and-prophets",
                    verse: "1Sam 9-10"
                },
                {
                    day: 5,
                    type: "gospels",
                    verse: "Mark 11:1-11"
                },
                {
                    day: 5,
                    type: "epistles",
                    verse: "2Cor 4"
                },
                {
                    day: 5,
                    type: "wisdom",
                    verse: "Ps 99"
                },
                {
                    day: 5,
                    type: "law-and-prophets",
                    verse: "1Sam 11-13"
                },
                {
                    day: 6,
                    type: "gospels",
                    verse: "Mark 11:12-26"
                },
                {
                    day: 6,
                    type: "epistles",
                    verse: "2Cor 5"
                },
                {
                    day: 6,
                    type: "wisdom",
                    verse: "Ps 100"
                },
                {
                    day: 6,
                    type: "law-and-prophets",
                    verse: "1Sam 14"
                },
                {
                    day: 7,
                    type: "gospels",
                    verse: "Mark 11:27-33"
                },
                {
                    day: 7,
                    type: "epistles",
                    verse: "2Cor 6"
                },
                {
                    day: 7,
                    type: "wisdom",
                    verse: "Ps 101"
                },
                {
                    day: 7,
                    type: "law-and-prophets",
                    verse: "1Sam 15-16"
                },
                {
                    day: 8,
                    type: "gospels",
                    verse: "Mark 12:1-12"
                },
                {
                    day: 8,
                    type: "epistles",
                    verse: "2Cor 7"
                },
                {
                    day: 8,
                    type: "wisdom",
                    verse: "Ps 102"
                },
                {
                    day: 8,
                    type: "law-and-prophets",
                    verse: "1Sam 17-18"
                },
                {
                    day: 9,
                    type: "gospels",
                    verse: "Mark 12:13-27"
                },
                {
                    day: 9,
                    type: "epistles",
                    verse: "2Cor 8"
                },
                {
                    day: 9,
                    type: "wisdom",
                    verse: "Ps 103"
                },
                {
                    day: 9,
                    type: "law-and-prophets",
                    verse: "1Sam 19-20"
                },
                {
                    day: 10,
                    type: "gospels",
                    verse: "Mark 12:28-34"
                },
                {
                    day: 10,
                    type: "epistles",
                    verse: "2Cor 9"
                },
                {
                    day: 10,
                    type: "wisdom",
                    verse: "Ps 104"
                },
                {
                    day: 10,
                    type: "law-and-prophets",
                    verse: "1Sam 21-23"
                },
                {
                    day: 11,
                    type: "gospels",
                    verse: "Mark 12:35-44"
                },
                {
                    day: 11,
                    type: "epistles",
                    verse: "2Cor 10"
                },
                {
                    day: 11,
                    type: "wisdom",
                    verse: "Ps 105"
                },
                {
                    day: 11,
                    type: "law-and-prophets",
                    verse: "1Sam 24-25"
                },
                {
                    day: 12,
                    type: "gospels",
                    verse: "Mark 13:1-13"
                },
                {
                    day: 12,
                    type: "epistles",
                    verse: "2Cor 11:1-15"
                },
                {
                    day: 12,
                    type: "wisdom",
                    verse: "Ps 106:1-23"
                },
                {
                    day: 12,
                    type: "law-and-prophets",
                    verse: "1Sam 26-28"
                },
                {
                    day: 13,
                    type: "gospels",
                    verse: "Mark 13:14-31"
                },
                {
                    day: 13,
                    type: "epistles",
                    verse: "2Cor 11:16-33"
                },
                {
                    day: 13,
                    type: "wisdom",
                    verse: "Ps 106:24-48"
                },
                {
                    day: 13,
                    type: "law-and-prophets",
                    verse: "1Sam 29-31"
                },
                {
                    day: 14,
                    type: "gospels",
                    verse: "Mark 13:32-37"
                },
                {
                    day: 14,
                    type: "epistles",
                    verse: "2Cor 12:1-10"
                },
                {
                    day: 14,
                    type: "wisdom",
                    verse: "Ps 107"
                },
                {
                    day: 14,
                    type: "law-and-prophets",
                    verse: "2Sam 1-2"
                },
                {
                    day: 15,
                    type: "gospels",
                    verse: "Mark 14:1-11"
                },
                {
                    day: 15,
                    type: "epistles",
                    verse: "2Cor 12:11-21"
                },
                {
                    day: 15,
                    type: "wisdom",
                    verse: "Ps 108"
                },
                {
                    day: 15,
                    type: "law-and-prophets",
                    verse: "2Sam 3-4"
                },
                {
                    day: 16,
                    type: "gospels",
                    verse: "Mark 14:12-31"
                },
                {
                    day: 16,
                    type: "epistles",
                    verse: "2Cor 13"
                },
                {
                    day: 16,
                    type: "wisdom",
                    verse: "Ps 109"
                },
                {
                    day: 16,
                    type: "law-and-prophets",
                    verse: "2Sam 5-7"
                },
                {
                    day: 17,
                    type: "gospels",
                    verse: "Mark 14:32-42"
                },
                {
                    day: 17,
                    type: "epistles",
                    verse: "Gal 1"
                },
                {
                    day: 17,
                    type: "wisdom",
                    verse: "Ps 110"
                },
                {
                    day: 17,
                    type: "law-and-prophets",
                    verse: "2Sam 8-10"
                },
                {
                    day: 18,
                    type: "gospels",
                    verse: "Mark 14:43-52"
                },
                {
                    day: 18,
                    type: "epistles",
                    verse: "Gal 2"
                },
                {
                    day: 18,
                    type: "wisdom",
                    verse: "Ps 111"
                },
                {
                    day: 18,
                    type: "law-and-prophets",
                    verse: "2Sam 11-12"
                },
                {
                    day: 19,
                    type: "gospels",
                    verse: "Mark 14:53-65"
                },
                {
                    day: 19,
                    type: "epistles",
                    verse: "Gal 3:1-14"
                },
                {
                    day: 19,
                    type: "wisdom",
                    verse: "Ps 112"
                },
                {
                    day: 19,
                    type: "law-and-prophets",
                    verse: "2Sam 13"
                },
                {
                    day: 20,
                    type: "gospels",
                    verse: "Mark 14:66-72"
                },
                {
                    day: 20,
                    type: "epistles",
                    verse: "Gal 3:15-29"
                },
                {
                    day: 20,
                    type: "wisdom",
                    verse: "Ps 113"
                },
                {
                    day: 20,
                    type: "law-and-prophets",
                    verse: "2Sam 14-15"
                },
                {
                    day: 21,
                    type: "gospels",
                    verse: "Mark 15:1-15"
                },
                {
                    day: 21,
                    type: "epistles",
                    verse: "Gal 4:1-20"
                },
                {
                    day: 21,
                    type: "wisdom",
                    verse: "Ps 114"
                },
                {
                    day: 21,
                    type: "law-and-prophets",
                    verse: "2Sam 16-17"
                },
                {
                    day: 22,
                    type: "gospels",
                    verse: "Mark 15:16-32"
                },
                {
                    day: 22,
                    type: "epistles",
                    verse: "Gal 4:21-31"
                },
                {
                    day: 22,
                    type: "wisdom",
                    verse: "Ps 115"
                },
                {
                    day: 22,
                    type: "law-and-prophets",
                    verse: "2Sam 18-19"
                },
                {
                    day: 23,
                    type: "gospels",
                    verse: "Mark 15:33-41"
                },
                {
                    day: 23,
                    type: "epistles",
                    verse: "Gal 5:1-12"
                },
                {
                    day: 23,
                    type: "wisdom",
                    verse: "Ps 116"
                },
                {
                    day: 23,
                    type: "law-and-prophets",
                    verse: "2Sam 20-21"
                },
                {
                    day: 24,
                    type: "gospels",
                    verse: "Mark 15:42-47"
                },
                {
                    day: 24,
                    type: "epistles",
                    verse: "Gal 5:13-26"
                },
                {
                    day: 24,
                    type: "wisdom",
                    verse: "Ps 117"
                },
                {
                    day: 24,
                    type: "law-and-prophets",
                    verse: "2Sam 22"
                },
                {
                    day: 25,
                    type: "gospels",
                    verse: "Mark 16"
                },
                {
                    day: 25,
                    type: "epistles",
                    verse: "Gal 6"
                },
                {
                    day: 25,
                    type: "wisdom",
                    verse: "Ps 118"
                },
                {
                    day: 25,
                    type: "law-and-prophets",
                    verse: "2Sam 23-24"
                }
            ]
        },
        {
            monthNum: 6,
            monthName: "JUNE",
            readings: [
                {
                    day: 1,
                    type: "gospels",
                    verse: "Luke 1:1-25"
                },
                {
                    day: 1,
                    type: "epistles",
                    verse: "Eph 1:1-14"
                },
                {
                    day: 1,
                    type: "wisdom",
                    verse: "Ps 119:1-8"
                },
                {
                    day: 1,
                    type: "law-and-prophets",
                    verse: "1Kgs 1"
                },
                {
                    day: 2,
                    type: "gospels",
                    verse: "Luke 1:26-38"
                },
                {
                    day: 2,
                    type: "epistles",
                    verse: "Eph 1:15-23"
                },
                {
                    day: 2,
                    type: "wisdom",
                    verse: "Ps 119:9-16"
                },
                {
                    day: 2,
                    type: "law-and-prophets",
                    verse: "1Kgs 2-3"
                },
                {
                    day: 3,
                    type: "gospels",
                    verse: "Luke 1:39-56"
                },
                {
                    day: 3,
                    type: "epistles",
                    verse: "Eph 2:1-10"
                },
                {
                    day: 3,
                    type: "wisdom",
                    verse: "Ps 119:17-24"
                },
                {
                    day: 3,
                    type: "law-and-prophets",
                    verse: "1Kgs 4-5"
                },
                {
                    day: 4,
                    type: "gospels",
                    verse: "Luke 1:57-66"
                },
                {
                    day: 4,
                    type: "epistles",
                    verse: "Eph 2:11-22"
                },
                {
                    day: 4,
                    type: "wisdom",
                    verse: "Ps 119:25-32"
                },
                {
                    day: 4,
                    type: "law-and-prophets",
                    verse: "1Kgs 6-7"
                },
                {
                    day: 5,
                    type: "gospels",
                    verse: "Luke 1:67-80"
                },
                {
                    day: 5,
                    type: "epistles",
                    verse: "Eph 3:1-13"
                },
                {
                    day: 5,
                    type: "wisdom",
                    verse: "Ps 119:33-40"
                },
                {
                    day: 5,
                    type: "law-and-prophets",
                    verse: "1Kgs 8"
                },
                {
                    day: 6,
                    type: "gospels",
                    verse: "Luke 2:1-20"
                },
                {
                    day: 6,
                    type: "epistles",
                    verse: "Eph 3:14-21"
                },
                {
                    day: 6,
                    type: "wisdom",
                    verse: "Ps 119:41-48"
                },
                {
                    day: 6,
                    type: "law-and-prophets",
                    verse: "1Kgs 9-10"
                },
                {
                    day: 7,
                    type: "gospels",
                    verse: "Luke 2:21-40"
                },
                {
                    day: 7,
                    type: "epistles",
                    verse: "Eph 4:1-16"
                },
                {
                    day: 7,
                    type: "wisdom",
                    verse: "Ps 119:49-56"
                },
                {
                    day: 7,
                    type: "law-and-prophets",
                    verse: "1Kgs 11"
                },
                {
                    day: 8,
                    type: "gospels",
                    verse: "Luke 2:41-52"
                },
                {
                    day: 8,
                    type: "epistles",
                    verse: "Eph 4:17-24"
                },
                {
                    day: 8,
                    type: "wisdom",
                    verse: "Ps 119:57-64"
                },
                {
                    day: 8,
                    type: "law-and-prophets",
                    verse: "1Kgs 12"
                },
                {
                    day: 9,
                    type: "gospels",
                    verse: "Luke 3:1-20"
                },
                {
                    day: 9,
                    type: "epistles",
                    verse: "Eph 4:25-32"
                },
                {
                    day: 9,
                    type: "wisdom",
                    verse: "Ps 119:65-72"
                },
                {
                    day: 9,
                    type: "law-and-prophets",
                    verse: "1Kgs 13-14"
                },
                {
                    day: 10,
                    type: "gospels",
                    verse: "Luke 3:21-38"
                },
                {
                    day: 10,
                    type: "epistles",
                    verse: "Eph 5:1-21"
                },
                {
                    day: 10,
                    type: "wisdom",
                    verse: "Ps 119:73-80"
                },
                {
                    day: 10,
                    type: "law-and-prophets",
                    verse: "1Kgs 15-16"
                },
                {
                    day: 11,
                    type: "gospels",
                    verse: "Luke 4:1-12"
                },
                {
                    day: 11,
                    type: "epistles",
                    verse: "Eph 5:22-33"
                },
                {
                    day: 11,
                    type: "wisdom",
                    verse: "Ps 119:81-88"
                },
                {
                    day: 11,
                    type: "law-and-prophets",
                    verse: "1Kgs 17-18"
                },
                {
                    day: 12,
                    type: "gospels",
                    verse: "Luke 4:13-30"
                },
                {
                    day: 12,
                    type: "epistles",
                    verse: "Eph 6:1-9"
                },
                {
                    day: 12,
                    type: "wisdom",
                    verse: "Ps 119:89-96"
                },
                {
                    day: 12,
                    type: "law-and-prophets",
                    verse: "1Kgs 19-20"
                },
                {
                    day: 13,
                    type: "gospels",
                    verse: "Luke 4:31-37"
                },
                {
                    day: 13,
                    type: "epistles",
                    verse: "Eph 6:10-24"
                },
                {
                    day: 13,
                    type: "wisdom",
                    verse: "Ps 119:97-104"
                },
                {
                    day: 13,
                    type: "law-and-prophets",
                    verse: "1Kgs 21-22"
                },
                {
                    day: 14,
                    type: "gospels",
                    verse: "Luke 4:38-44"
                },
                {
                    day: 14,
                    type: "epistles",
                    verse: "Phil 1:1-11"
                },
                {
                    day: 14,
                    type: "wisdom",
                    verse: "Ps 119:105-112"
                },
                {
                    day: 14,
                    type: "law-and-prophets",
                    verse: "2Kgs 1-3"
                },
                {
                    day: 15,
                    type: "gospels",
                    verse: "Luke 5:1-11"
                },
                {
                    day: 15,
                    type: "epistles",
                    verse: "Phil 1:12-20"
                },
                {
                    day: 15,
                    type: "wisdom",
                    verse: "Ps 119:113-120"
                },
                {
                    day: 15,
                    type: "law-and-prophets",
                    verse: "2Kgs 4-5"
                },
                {
                    day: 16,
                    type: "gospels",
                    verse: "Luke 5:12-16"
                },
                {
                    day: 16,
                    type: "epistles",
                    verse: "Phil 1:21-30"
                },
                {
                    day: 16,
                    type: "wisdom",
                    verse: "Ps 119:121-128"
                },
                {
                    day: 16,
                    type: "law-and-prophets",
                    verse: "2Kgs 6-7"
                },
                {
                    day: 17,
                    type: "gospels",
                    verse: "Luke 5:17-26"
                },
                {
                    day: 17,
                    type: "epistles",
                    verse: "Phil 2:1-11"
                },
                {
                    day: 17,
                    type: "wisdom",
                    verse: "Ps 119:129-136"
                },
                {
                    day: 17,
                    type: "law-and-prophets",
                    verse: "2Kgs 8-9"
                },
                {
                    day: 18,
                    type: "gospels",
                    verse: "Luke 5:27-32"
                },
                {
                    day: 18,
                    type: "epistles",
                    verse: "Phil 2:12-18"
                },
                {
                    day: 18,
                    type: "wisdom",
                    verse: "Ps 119:137-144"
                },
                {
                    day: 18,
                    type: "law-and-prophets",
                    verse: "2Kgs 10-11"
                },
                {
                    day: 19,
                    type: "gospels",
                    verse: "Luke 5:33-39"
                },
                {
                    day: 19,
                    type: "epistles",
                    verse: "Phil 2:19-30"
                },
                {
                    day: 19,
                    type: "wisdom",
                    verse: "Ps 119:145-152"
                },
                {
                    day: 19,
                    type: "law-and-prophets",
                    verse: "2Kgs 12-13"
                },
                {
                    day: 20,
                    type: "gospels",
                    verse: "Luke 6:1-16"
                },
                {
                    day: 20,
                    type: "epistles",
                    verse: "Phil 3:1-9"
                },
                {
                    day: 20,
                    type: "wisdom",
                    verse: "Ps 119:153-160"
                },
                {
                    day: 20,
                    type: "law-and-prophets",
                    verse: "2Kgs 14-15"
                },
                {
                    day: 21,
                    type: "gospels",
                    verse: "Luke 6:17-26"
                },
                {
                    day: 21,
                    type: "epistles",
                    verse: "Phil 3:10-14"
                },
                {
                    day: 21,
                    type: "wisdom",
                    verse: "Ps 119:161-168"
                },
                {
                    day: 21,
                    type: "law-and-prophets",
                    verse: "2Kgs 16-17"
                },
                {
                    day: 22,
                    type: "gospels",
                    verse: "Luke 6:27-36"
                },
                {
                    day: 22,
                    type: "epistles",
                    verse: "Phil 3:15-21"
                },
                {
                    day: 22,
                    type: "wisdom",
                    verse: "Ps 119:169-176"
                },
                {
                    day: 22,
                    type: "law-and-prophets",
                    verse: "2Kgs 18-19"
                },
                {
                    day: 23,
                    type: "gospels",
                    verse: "Luke 6:37-42"
                },
                {
                    day: 23,
                    type: "epistles",
                    verse: "Phil 4:1-7"
                },
                {
                    day: 23,
                    type: "wisdom",
                    verse: "Ps 120"
                },
                {
                    day: 23,
                    type: "law-and-prophets",
                    verse: "2Kgs 20-21"
                },
                {
                    day: 24,
                    type: "gospels",
                    verse: "Luke 6:43-49"
                },
                {
                    day: 24,
                    type: "epistles",
                    verse: "Phil 4:8-13"
                },
                {
                    day: 24,
                    type: "wisdom",
                    verse: "Ps 121"
                },
                {
                    day: 24,
                    type: "law-and-prophets",
                    verse: "2Kgs 22-23"
                },
                {
                    day: 25,
                    type: "gospels",
                    verse: "Luke 7:1-10"
                },
                {
                    day: 25,
                    type: "epistles",
                    verse: "Phil 4:14-23"
                },
                {
                    day: 25,
                    type: "wisdom",
                    verse: "Ps 122"
                },
                {
                    day: 25,
                    type: "law-and-prophets",
                    verse: "2Kgs 24-25"
                }
            ]
        },
        {
            monthNum: 7,
            monthName: "JULY",
            readings: [
                {
                    day: 1,
                    type: "gospels",
                    verse: "Luke 7:11-17"
                },
                {
                    day: 1,
                    type: "epistles",
                    verse: "Col 1:1-14"
                },
                {
                    day: 1,
                    type: "wisdom",
                    verse: "Ps 123-124"
                },
                {
                    day: 1,
                    type: "law-and-prophets",
                    verse: "1Chr 1-2"
                },
                {
                    day: 2,
                    type: "gospels",
                    verse: "Luke 7:18-35"
                },
                {
                    day: 2,
                    type: "epistles",
                    verse: "Col 1:15-29"
                },
                {
                    day: 2,
                    type: "wisdom",
                    verse: "Ps 125"
                },
                {
                    day: 2,
                    type: "law-and-prophets",
                    verse: "1Chr 3-4"
                },
                {
                    day: 3,
                    type: "gospels",
                    verse: "Luke 7:36-50"
                },
                {
                    day: 3,
                    type: "epistles",
                    verse: "Col 2:1-7"
                },
                {
                    day: 3,
                    type: "wisdom",
                    verse: "Ps 126"
                },
                {
                    day: 3,
                    type: "law-and-prophets",
                    verse: "1Chr 5-6"
                },
                {
                    day: 4,
                    type: "gospels",
                    verse: "Luke 8:1-15"
                },
                {
                    day: 4,
                    type: "epistles",
                    verse: "Col 2:8-15"
                },
                {
                    day: 4,
                    type: "wisdom",
                    verse: "Ps 127"
                },
                {
                    day: 4,
                    type: "law-and-prophets",
                    verse: "1Chr 7-9"
                },
                {
                    day: 5,
                    type: "gospels",
                    verse: "Luke 8:16-25"
                },
                {
                    day: 5,
                    type: "epistles",
                    verse: "Col 2:16-23"
                },
                {
                    day: 5,
                    type: "wisdom",
                    verse: "Ps 128"
                },
                {
                    day: 5,
                    type: "law-and-prophets",
                    verse: "1Chr 10-11"
                },
                {
                    day: 6,
                    type: "gospels",
                    verse: "Luke 8:26-39"
                },
                {
                    day: 6,
                    type: "epistles",
                    verse: "Col 3:1-14"
                },
                {
                    day: 6,
                    type: "wisdom",
                    verse: "Ps 129"
                },
                {
                    day: 6,
                    type: "law-and-prophets",
                    verse: "1Chr 12-14"
                },
                {
                    day: 7,
                    type: "gospels",
                    verse: "Luke 8:40-56"
                },
                {
                    day: 7,
                    type: "epistles",
                    verse: "Col 3:15-25"
                },
                {
                    day: 7,
                    type: "wisdom",
                    verse: "Ps 130-131"
                },
                {
                    day: 7,
                    type: "law-and-prophets",
                    verse: "1Chr 15-16"
                },
                {
                    day: 8,
                    type: "gospels",
                    verse: "Luke 9:1-17"
                },
                {
                    day: 8,
                    type: "epistles",
                    verse: "Col 4:1-9"
                },
                {
                    day: 8,
                    type: "wisdom",
                    verse: "Ps 132"
                },
                {
                    day: 8,
                    type: "law-and-prophets",
                    verse: "1Chr 17-19"
                },
                {
                    day: 9,
                    type: "gospels",
                    verse: "Luke 9:18-27"
                },
                {
                    day: 9,
                    type: "epistles",
                    verse: "Col 4:10-18"
                },
                {
                    day: 9,
                    type: "wisdom",
                    verse: "Ps 133-134"
                },
                {
                    day: 9,
                    type: "law-and-prophets",
                    verse: "1Chr 20-22"
                },
                {
                    day: 10,
                    type: "gospels",
                    verse: "Luke 9:28-36"
                },
                {
                    day: 10,
                    type: "epistles",
                    verse: "1Thess 1"
                },
                {
                    day: 10,
                    type: "wisdom",
                    verse: "Ps 135"
                },
                {
                    day: 10,
                    type: "law-and-prophets",
                    verse: "1Chr 23-25"
                },
                {
                    day: 11,
                    type: "gospels",
                    verse: "Luke 9:37-50"
                },
                {
                    day: 11,
                    type: "epistles",
                    verse: "1Thess 2:1-9"
                },
                {
                    day: 11,
                    type: "wisdom",
                    verse: "Ps 136"
                },
                {
                    day: 11,
                    type: "law-and-prophets",
                    verse: "1Chr 26-28"
                },
                {
                    day: 12,
                    type: "gospels",
                    verse: "Luke 9:51-62"
                },
                {
                    day: 12,
                    type: "epistles",
                    verse: "1Thess 2:10-20"
                },
                {
                    day: 12,
                    type: "wisdom",
                    verse: "Ps 137"
                },
                {
                    day: 12,
                    type: "law-and-prophets",
                    verse: "1Chr 29"
                },
                {
                    day: 13,
                    type: "gospels",
                    verse: "Luke 10:1-16"
                },
                {
                    day: 13,
                    type: "epistles",
                    verse: "1Thess 3:1-6"
                },
                {
                    day: 13,
                    type: "wisdom",
                    verse: "Ps 138"
                },
                {
                    day: 13,
                    type: "law-and-prophets",
                    verse: "2Chr 1-2"
                },
                {
                    day: 14,
                    type: "gospels",
                    verse: "Luke 10:17-24"
                },
                {
                    day: 14,
                    type: "epistles",
                    verse: "1Thess 3:7-13"
                },
                {
                    day: 14,
                    type: "wisdom",
                    verse: "Ps 139"
                },
                {
                    day: 14,
                    type: "law-and-prophets",
                    verse: "2Chr 3-5"
                },
                {
                    day: 15,
                    type: "gospels",
                    verse: "Luke 10:25-37"
                },
                {
                    day: 15,
                    type: "epistles",
                    verse: "1Thess 4:1-10"
                },
                {
                    day: 15,
                    type: "wisdom",
                    verse: "Ps 140"
                },
                {
                    day: 15,
                    type: "law-and-prophets",
                    verse: "2Chr 6-7"
                },
                {
                    day: 16,
                    type: "gospels",
                    verse: "Luke 10:38-42"
                },
                {
                    day: 16,
                    type: "epistles",
                    verse: "1Thess 4:11-18"
                },
                {
                    day: 16,
                    type: "wisdom",
                    verse: "Ps 141"
                },
                {
                    day: 16,
                    type: "law-and-prophets",
                    verse: "2Chr 8-9"
                },
                {
                    day: 17,
                    type: "gospels",
                    verse: "Luke 11:1-13"
                },
                {
                    day: 17,
                    type: "epistles",
                    verse: "1Thess 5:1-11"
                },
                {
                    day: 17,
                    type: "wisdom",
                    verse: "Ps 142"
                },
                {
                    day: 17,
                    type: "law-and-prophets",
                    verse: "2Chr 10-12"
                },
                {
                    day: 18,
                    type: "gospels",
                    verse: "Luke 11:14-28"
                },
                {
                    day: 18,
                    type: "epistles",
                    verse: "1Thess 5:12-28"
                },
                {
                    day: 18,
                    type: "wisdom",
                    verse: "Ps 143"
                },
                {
                    day: 18,
                    type: "law-and-prophets",
                    verse: "2Chr 13-16"
                },
                {
                    day: 19,
                    type: "gospels",
                    verse: "Luke 11:29-36"
                },
                {
                    day: 19,
                    type: "epistles",
                    verse: "2Thess 1:1-7"
                },
                {
                    day: 19,
                    type: "wisdom",
                    verse: "Ps 144"
                },
                {
                    day: 19,
                    type: "law-and-prophets",
                    verse: "2Chr 17-19"
                },
                {
                    day: 20,
                    type: "gospels",
                    verse: "Luke 11:37-54"
                },
                {
                    day: 20,
                    type: "epistles",
                    verse: "2Thess 1:8-12"
                },
                {
                    day: 20,
                    type: "wisdom",
                    verse: "Ps 145"
                },
                {
                    day: 20,
                    type: "law-and-prophets",
                    verse: "2Chr 20-21"
                },
                {
                    day: 21,
                    type: "gospels",
                    verse: "Luke 12:1-12"
                },
                {
                    day: 21,
                    type: "epistles",
                    verse: "2Thess 2:1-12"
                },
                {
                    day: 21,
                    type: "wisdom",
                    verse: "Ps 146"
                },
                {
                    day: 21,
                    type: "law-and-prophets",
                    verse: "2Chr 22-24"
                },
                {
                    day: 22,
                    type: "gospels",
                    verse: "Luke 12:13-21"
                },
                {
                    day: 22,
                    type: "epistles",
                    verse: "2Thess 2:13-17"
                },
                {
                    day: 22,
                    type: "wisdom",
                    verse: "Ps 147"
                },
                {
                    day: 22,
                    type: "law-and-prophets",
                    verse: "2Chr 25-27"
                },
                {
                    day: 23,
                    type: "gospels",
                    verse: "Luke 12:22-34"
                },
                {
                    day: 23,
                    type: "epistles",
                    verse: "2Thess 3:1-5"
                },
                {
                    day: 23,
                    type: "wisdom",
                    verse: "Ps 148"
                },
                {
                    day: 23,
                    type: "law-and-prophets",
                    verse: "2Chr 28-29"
                },
                {
                    day: 24,
                    type: "gospels",
                    verse: "Luke 12:35-48"
                },
                {
                    day: 24,
                    type: "epistles",
                    verse: "2Thess 3:6-13"
                },
                {
                    day: 24,
                    type: "wisdom",
                    verse: "Ps 149"
                },
                {
                    day: 24,
                    type: "law-and-prophets",
                    verse: "2Chr 30-33"
                },
                {
                    day: 25,
                    type: "gospels",
                    verse: "Luke 12:49-59"
                },
                {
                    day: 25,
                    type: "epistles",
                    verse: "2Thess 3:14-18"
                },
                {
                    day: 25,
                    type: "wisdom",
                    verse: "Ps 150"
                },
                {
                    day: 25,
                    type: "law-and-prophets",
                    verse: "2Chr 34-36"
                }
            ]
        },
        {
            monthNum: 8,
            monthName: "AUGUST",
            readings: [
                {
                    day: 1,
                    type: "gospels",
                    verse: "Luke 13:1-9"
                },
                {
                    day: 1,
                    type: "epistles",
                    verse: "1Tim 1:1-11"
                },
                {
                    day: 1,
                    type: "wisdom",
                    verse: "Prov 1"
                },
                {
                    day: 1,
                    type: "law-and-prophets",
                    verse: "Ezra 1-2"
                },
                {
                    day: 2,
                    type: "gospels",
                    verse: "Luke 13:10-21"
                },
                {
                    day: 2,
                    type: "epistles",
                    verse: "1Tim 1:12-20"
                },
                {
                    day: 2,
                    type: "wisdom",
                    verse: "Prov 2"
                },
                {
                    day: 2,
                    type: "law-and-prophets",
                    verse: "Ezra 3"
                },
                {
                    day: 3,
                    type: "gospels",
                    verse: "Luke 13:22-35"
                },
                {
                    day: 3,
                    type: "epistles",
                    verse: "1Tim 2"
                },
                {
                    day: 3,
                    type: "wisdom",
                    verse: "Prov 3"
                },
                {
                    day: 3,
                    type: "law-and-prophets",
                    verse: "Ezra 4-5"
                },
                {
                    day: 4,
                    type: "gospels",
                    verse: "Luke 14:1-14"
                },
                {
                    day: 4,
                    type: "epistles",
                    verse: "1Tim 3:1-10"
                },
                {
                    day: 4,
                    type: "wisdom",
                    verse: "Prov 4"
                },
                {
                    day: 4,
                    type: "law-and-prophets",
                    verse: "Ezra 6"
                },
                {
                    day: 5,
                    type: "gospels",
                    verse: "Luke 14:15-24"
                },
                {
                    day: 5,
                    type: "epistles",
                    verse: "1Tim 3:11-16"
                },
                {
                    day: 5,
                    type: "wisdom",
                    verse: "Prov 5"
                },
                {
                    day: 5,
                    type: "law-and-prophets",
                    verse: "Ezra 7"
                },
                {
                    day: 6,
                    type: "gospels",
                    verse: "Luke 14:25-35"
                },
                {
                    day: 6,
                    type: "epistles",
                    verse: "1Tim 4"
                },
                {
                    day: 6,
                    type: "wisdom",
                    verse: "Prov 6"
                },
                {
                    day: 6,
                    type: "law-and-prophets",
                    verse: "Ezra 8"
                },
                {
                    day: 7,
                    type: "gospels",
                    verse: "Luke 15:1-10"
                },
                {
                    day: 7,
                    type: "epistles",
                    verse: "1Tim 5:1-15"
                },
                {
                    day: 7,
                    type: "wisdom",
                    verse: "Prov 7"
                },
                {
                    day: 7,
                    type: "law-and-prophets",
                    verse: "Ezra 9"
                },
                {
                    day: 8,
                    type: "gospels",
                    verse: "Luke 15:11-32"
                },
                {
                    day: 8,
                    type: "epistles",
                    verse: "1Tim 5:16-25"
                },
                {
                    day: 8,
                    type: "wisdom",
                    verse: "Prov 8"
                },
                {
                    day: 8,
                    type: "law-and-prophets",
                    verse: "Ezra 10"
                },
                {
                    day: 9,
                    type: "gospels",
                    verse: "Luke 16:1-9"
                },
                {
                    day: 9,
                    type: "epistles",
                    verse: "1Tim 6:1-10"
                },
                {
                    day: 9,
                    type: "wisdom",
                    verse: "Prov 9"
                },
                {
                    day: 9,
                    type: "law-and-prophets",
                    verse: "Neh 1-2"
                },
                {
                    day: 10,
                    type: "gospels",
                    verse: "Luke 16:10-18"
                },
                {
                    day: 10,
                    type: "epistles",
                    verse: "1Tim 6:11-21"
                },
                {
                    day: 10,
                    type: "wisdom",
                    verse: "Prov 10:1-16"
                },
                {
                    day: 10,
                    type: "law-and-prophets",
                    verse: "Neh 3"
                },
                {
                    day: 11,
                    type: "gospels",
                    verse: "Luke 16:19-31"
                },
                {
                    day: 11,
                    type: "epistles",
                    verse: "2Tim 1:1-7"
                },
                {
                    day: 11,
                    type: "wisdom",
                    verse: "Prov 10:17-32"
                },
                {
                    day: 11,
                    type: "law-and-prophets",
                    verse: "Neh 4-5"
                },
                {
                    day: 12,
                    type: "gospels",
                    verse: "Luke 17:1-10"
                },
                {
                    day: 12,
                    type: "epistles",
                    verse: "2Tim 1:8-18"
                },
                {
                    day: 12,
                    type: "wisdom",
                    verse: "Prov 11:1-15"
                },
                {
                    day: 12,
                    type: "law-and-prophets",
                    verse: "Neh 6"
                },
                {
                    day: 13,
                    type: "gospels",
                    verse: "Luke 17:11-19"
                },
                {
                    day: 13,
                    type: "epistles",
                    verse: "2Tim 2:1-13"
                },
                {
                    day: 13,
                    type: "wisdom",
                    verse: "Prov 11:16-31"
                },
                {
                    day: 13,
                    type: "law-and-prophets",
                    verse: "Neh 7"
                },
                {
                    day: 14,
                    type: "gospels",
                    verse: "Luke 17:20-37"
                },
                {
                    day: 14,
                    type: "epistles",
                    verse: "2Tim 2:14-26"
                },
                {
                    day: 14,
                    type: "wisdom",
                    verse: "Prov 12:1-14"
                },
                {
                    day: 14,
                    type: "law-and-prophets",
                    verse: "Neh 8"
                },
                {
                    day: 15,
                    type: "gospels",
                    verse: "Luke 18:1-8"
                },
                {
                    day: 15,
                    type: "epistles",
                    verse: "2Tim 3:1-9"
                },
                {
                    day: 15,
                    type: "wisdom",
                    verse: "Prov 12:15-28"
                },
                {
                    day: 15,
                    type: "law-and-prophets",
                    verse: "Neh 9"
                },
                {
                    day: 16,
                    type: "gospels",
                    verse: "Luke 18:9-17"
                },
                {
                    day: 16,
                    type: "epistles",
                    verse: "2Tim 3:10-17"
                },
                {
                    day: 16,
                    type: "wisdom",
                    verse: "Prov 13:1-12"
                },
                {
                    day: 16,
                    type: "law-and-prophets",
                    verse: "Neh 10"
                },
                {
                    day: 17,
                    type: "gospels",
                    verse: "Luke 18:18-30"
                },
                {
                    day: 17,
                    type: "epistles",
                    verse: "2Tim 4"
                },
                {
                    day: 17,
                    type: "wisdom",
                    verse: "Prov 13:13-25"
                },
                {
                    day: 17,
                    type: "law-and-prophets",
                    verse: "Neh 11"
                },
                {
                    day: 18,
                    type: "gospels",
                    verse: "Luke 18:31-43"
                },
                {
                    day: 18,
                    type: "epistles",
                    verse: "Titus 1:1-9"
                },
                {
                    day: 18,
                    type: "wisdom",
                    verse: "Prov 14:1-18"
                },
                {
                    day: 18,
                    type: "law-and-prophets",
                    verse: "Neh 12"
                },
                {
                    day: 19,
                    type: "gospels",
                    verse: "Luke 19:1-10"
                },
                {
                    day: 19,
                    type: "epistles",
                    verse: "Titus 1:10-16"
                },
                {
                    day: 19,
                    type: "wisdom",
                    verse: "Prov 14:19-35"
                },
                {
                    day: 19,
                    type: "law-and-prophets",
                    verse: "Neh 13"
                },
                {
                    day: 20,
                    type: "gospels",
                    verse: "Luke 19:11-27"
                },
                {
                    day: 20,
                    type: "epistles",
                    verse: "Titus 2:1-10"
                },
                {
                    day: 20,
                    type: "wisdom",
                    verse: "Prov 15:1-17"
                },
                {
                    day: 20,
                    type: "law-and-prophets",
                    verse: "Esth 1"
                },
                {
                    day: 21,
                    type: "gospels",
                    verse: "Luke 19:28-38"
                },
                {
                    day: 21,
                    type: "epistles",
                    verse: "Titus 2:11-15"
                },
                {
                    day: 21,
                    type: "wisdom",
                    verse: "Prov 15:18-33"
                },
                {
                    day: 21,
                    type: "law-and-prophets",
                    verse: "Esth 2"
                },
                {
                    day: 22,
                    type: "gospels",
                    verse: "Luke 19:39-48"
                },
                {
                    day: 22,
                    type: "epistles",
                    verse: "Titus 3:1-8"
                },
                {
                    day: 22,
                    type: "wisdom",
                    verse: "Prov 16:1-16"
                },
                {
                    day: 22,
                    type: "law-and-prophets",
                    verse: "Esth 3-4"
                },
                {
                    day: 23,
                    type: "gospels",
                    verse: "Luke 20:1-8"
                },
                {
                    day: 23,
                    type: "epistles",
                    verse: "Titus 3:9-15"
                },
                {
                    day: 23,
                    type: "wisdom",
                    verse: "Prov 16:17-33"
                },
                {
                    day: 23,
                    type: "law-and-prophets",
                    verse: "Esth 5-6"
                },
                {
                    day: 24,
                    type: "gospels",
                    verse: "Luke 20:9-19"
                },
                {
                    day: 24,
                    type: "epistles",
                    verse: "Phlm 1-11"
                },
                {
                    day: 24,
                    type: "wisdom",
                    verse: "Prov 17:1-14"
                },
                {
                    day: 24,
                    type: "law-and-prophets",
                    verse: "Esth 7-8"
                },
                {
                    day: 25,
                    type: "gospels",
                    verse: "Luke 20:20-26"
                },
                {
                    day: 25,
                    type: "epistles",
                    verse: "Phlm 12-25"
                },
                {
                    day: 25,
                    type: "wisdom",
                    verse: "Prov 17:15-28"
                },
                {
                    day: 25,
                    type: "law-and-prophets",
                    verse: "Esth 9-10"
                }
            ]
        },
        {
            monthNum: 9,
            monthName: "SEPTEMBER",
            readings: [
                {
                    day: 1,
                    type: "gospels",
                    verse: "Luke 20:27-40"
                },
                {
                    day: 1,
                    type: "epistles",
                    verse: "Heb 1:1-9"
                },
                {
                    day: 1,
                    type: "wisdom",
                    verse: "Prov 18"
                },
                {
                    day: 1,
                    type: "law-and-prophets",
                    verse: "Isa 1-2"
                },
                {
                    day: 2,
                    type: "gospels",
                    verse: "Luke 20:41-47"
                },
                {
                    day: 2,
                    type: "epistles",
                    verse: "Heb 1:10-14"
                },
                {
                    day: 2,
                    type: "wisdom",
                    verse: "Prov 19:1-14"
                },
                {
                    day: 2,
                    type: "law-and-prophets",
                    verse: "Isa 3-5"
                },
                {
                    day: 3,
                    type: "gospels",
                    verse: "Luke 21:1-19"
                },
                {
                    day: 3,
                    type: "epistles",
                    verse: "Heb 2:1-9"
                },
                {
                    day: 3,
                    type: "wisdom",
                    verse: "Prov 19:15-29"
                },
                {
                    day: 3,
                    type: "law-and-prophets",
                    verse: "Isa 6-8"
                },
                {
                    day: 4,
                    type: "gospels",
                    verse: "Luke 21:20-28"
                },
                {
                    day: 4,
                    type: "epistles",
                    verse: "Heb 2:10-18"
                },
                {
                    day: 4,
                    type: "wisdom",
                    verse: "Prov 20:1-15"
                },
                {
                    day: 4,
                    type: "law-and-prophets",
                    verse: "Isa 9-10"
                },
                {
                    day: 5,
                    type: "gospels",
                    verse: "Luke 21:29-38"
                },
                {
                    day: 5,
                    type: "epistles",
                    verse: "Heb 3"
                },
                {
                    day: 5,
                    type: "wisdom",
                    verse: "Prov 20:16-30"
                },
                {
                    day: 5,
                    type: "law-and-prophets",
                    verse: "Isa 11-13"
                },
                {
                    day: 6,
                    type: "gospels",
                    verse: "Luke 22:1-13"
                },
                {
                    day: 6,
                    type: "epistles",
                    verse: "Heb 4:1-11"
                },
                {
                    day: 6,
                    type: "wisdom",
                    verse: "Prov 21:1-16"
                },
                {
                    day: 6,
                    type: "law-and-prophets",
                    verse: "Isa 14-16"
                },
                {
                    day: 7,
                    type: "gospels",
                    verse: "Luke 22:14-23"
                },
                {
                    day: 7,
                    type: "epistles",
                    verse: "Heb 4:12-16"
                },
                {
                    day: 7,
                    type: "wisdom",
                    verse: "Prov 21:17-31"
                },
                {
                    day: 7,
                    type: "law-and-prophets",
                    verse: "Isa 17-20"
                },
                {
                    day: 8,
                    type: "gospels",
                    verse: "Luke 22:24-30"
                },
                {
                    day: 8,
                    type: "epistles",
                    verse: "Heb 5"
                },
                {
                    day: 8,
                    type: "wisdom",
                    verse: "Prov 22:1-16"
                },
                {
                    day: 8,
                    type: "law-and-prophets",
                    verse: "Isa 21-23"
                },
                {
                    day: 9,
                    type: "gospels",
                    verse: "Luke 22:31-38"
                },
                {
                    day: 9,
                    type: "epistles",
                    verse: "Heb 6:1-12"
                },
                {
                    day: 9,
                    type: "wisdom",
                    verse: "Prov 22:17-29"
                },
                {
                    day: 9,
                    type: "law-and-prophets",
                    verse: "Isa 24-26"
                },
                {
                    day: 10,
                    type: "gospels",
                    verse: "Luke 22:39:46"
                },
                {
                    day: 10,
                    type: "epistles",
                    verse: "Heb 6:13-20"
                },
                {
                    day: 10,
                    type: "wisdom",
                    verse: "Prov 23:1-18"
                },
                {
                    day: 10,
                    type: "law-and-prophets",
                    verse: "Isa 27-28"
                },
                {
                    day: 11,
                    type: "gospels",
                    verse: "Luke 22:47-53"
                },
                {
                    day: 11,
                    type: "epistles",
                    verse: "Heb 7:1-10"
                },
                {
                    day: 11,
                    type: "wisdom",
                    verse: "Prov 23:19-35"
                },
                {
                    day: 11,
                    type: "law-and-prophets",
                    verse: "Isa 29-30"
                },
                {
                    day: 12,
                    type: "gospels",
                    verse: "Luke 22:54-62"
                },
                {
                    day: 12,
                    type: "epistles",
                    verse: "Heb 7:11-28"
                },
                {
                    day: 12,
                    type: "wisdom",
                    verse: "Prov 24:1-22"
                },
                {
                    day: 12,
                    type: "law-and-prophets",
                    verse: "Isa 31-33"
                },
                {
                    day: 13,
                    type: "gospels",
                    verse: "Luke 22:63-71"
                },
                {
                    day: 13,
                    type: "epistles",
                    verse: "Heb 8:1-6"
                },
                {
                    day: 13,
                    type: "wisdom",
                    verse: "Prov 24:23-34"
                },
                {
                    day: 13,
                    type: "law-and-prophets",
                    verse: "Isa 34-36"
                },
                {
                    day: 14,
                    type: "gospels",
                    verse: "Luke 23:1-12"
                },
                {
                    day: 14,
                    type: "epistles",
                    verse: "Heb 8:7-13"
                },
                {
                    day: 14,
                    type: "wisdom",
                    verse: "Prov 25:1-14"
                },
                {
                    day: 14,
                    type: "law-and-prophets",
                    verse: "Isa 37-39"
                },
                {
                    day: 15,
                    type: "gospels",
                    verse: "Luke 23:13-25"
                },
                {
                    day: 15,
                    type: "epistles",
                    verse: "Heb 9:1-10"
                },
                {
                    day: 15,
                    type: "wisdom",
                    verse: "Prov 25:15-28"
                },
                {
                    day: 15,
                    type: "law-and-prophets",
                    verse: "Isa 40-41"
                },
                {
                    day: 16,
                    type: "gospels",
                    verse: "Luke 23:26-31"
                },
                {
                    day: 16,
                    type: "epistles",
                    verse: "Heb 9:11-28"
                },
                {
                    day: 16,
                    type: "wisdom",
                    verse: "Prov 26:1-16"
                },
                {
                    day: 16,
                    type: "law-and-prophets",
                    verse: "Isa 42-43"
                },
                {
                    day: 17,
                    type: "gospels",
                    verse: "Luke 23:32-37"
                },
                {
                    day: 17,
                    type: "epistles",
                    verse: "Heb 10:1-18"
                },
                {
                    day: 17,
                    type: "wisdom",
                    verse: "Prov 26:17-28"
                },
                {
                    day: 17,
                    type: "law-and-prophets",
                    verse: "Isa 44-45"
                },
                {
                    day: 18,
                    type: "gospels",
                    verse: "Luke 23:38-43"
                },
                {
                    day: 18,
                    type: "epistles",
                    verse: "Heb 10:19-39"
                },
                {
                    day: 18,
                    type: "wisdom",
                    verse: "Prov 27:1-14"
                },
                {
                    day: 18,
                    type: "law-and-prophets",
                    verse: "Isa 46-48"
                },
                {
                    day: 19,
                    type: "gospels",
                    verse: "Luke 23:44-49"
                },
                {
                    day: 19,
                    type: "epistles",
                    verse: "Heb 11:1-16"
                },
                {
                    day: 19,
                    type: "wisdom",
                    verse: "Prov 27:15-27"
                },
                {
                    day: 19,
                    type: "law-and-prophets",
                    verse: "Isa 49-50"
                },
                {
                    day: 20,
                    type: "gospels",
                    verse: "Luke 23:50-56"
                },
                {
                    day: 20,
                    type: "epistles",
                    verse: "Heb 11:17-31"
                },
                {
                    day: 20,
                    type: "wisdom",
                    verse: "Prov 28:1-14"
                },
                {
                    day: 20,
                    type: "law-and-prophets",
                    verse: "Isa 51-53"
                },
                {
                    day: 21,
                    type: "gospels",
                    verse: "Luke 24:1-12"
                },
                {
                    day: 21,
                    type: "epistles",
                    verse: "Heb 11:32-40"
                },
                {
                    day: 21,
                    type: "wisdom",
                    verse: "Prov 28:15-28"
                },
                {
                    day: 21,
                    type: "law-and-prophets",
                    verse: "Isa 54-55"
                },
                {
                    day: 22,
                    type: "gospels",
                    verse: "Luke 24:13-27"
                },
                {
                    day: 22,
                    type: "epistles",
                    verse: "Heb 12:1-13"
                },
                {
                    day: 22,
                    type: "wisdom",
                    verse: "Prov 29:1-14"
                },
                {
                    day: 22,
                    type: "law-and-prophets",
                    verse: "Isa 56-58"
                },
                {
                    day: 23,
                    type: "gospels",
                    verse: "Luke 24:28-35"
                },
                {
                    day: 23,
                    type: "epistles",
                    verse: "Heb 12:14-29"
                },
                {
                    day: 23,
                    type: "wisdom",
                    verse: "Prov 29:15-27"
                },
                {
                    day: 23,
                    type: "law-and-prophets",
                    verse: "Isa 59-61"
                },
                {
                    day: 24,
                    type: "gospels",
                    verse: "Luke 24:36-44"
                },
                {
                    day: 24,
                    type: "epistles",
                    verse: "Heb 13:1-8"
                },
                {
                    day: 24,
                    type: "wisdom",
                    verse: "Prov 30"
                },
                {
                    day: 24,
                    type: "law-and-prophets",
                    verse: "Isa 62-64"
                },
                {
                    day: 25,
                    type: "gospels",
                    verse: "Luke 24:45-53"
                },
                {
                    day: 25,
                    type: "epistles",
                    verse: "Heb 13:9-25"
                },
                {
                    day: 25,
                    type: "wisdom",
                    verse: "Prov 31"
                },
                {
                    day: 25,
                    type: "law-and-prophets",
                    verse: "Isa 65-66"
                }
            ]
        },
        {
            monthNum: 10,
            monthName: "OCTOBER",
            readings: [
                {
                    day: 1,
                    type: "gospels",
                    verse: "John 1:1-18"
                },
                {
                    day: 1,
                    type: "epistles",
                    verse: "Jas 1:1-11"
                },
                {
                    day: 1,
                    type: "wisdom",
                    verse: "Eccl 1"
                },
                {
                    day: 1,
                    type: "law-and-prophets",
                    verse: "Jer 1-2"
                },
                {
                    day: 2,
                    type: "gospels",
                    verse: "John 1:19-28"
                },
                {
                    day: 2,
                    type: "epistles",
                    verse: "Jas 1:12-18"
                },
                {
                    day: 2,
                    type: "wisdom",
                    verse: "Eccl 2:1-16"
                },
                {
                    day: 2,
                    type: "law-and-prophets",
                    verse: "Jer 3-4"
                },
                {
                    day: 3,
                    type: "gospels",
                    verse: "John 1:29-34"
                },
                {
                    day: 3,
                    type: "epistles",
                    verse: "Jas 1:19-27"
                },
                {
                    day: 3,
                    type: "wisdom",
                    verse: "Eccl 2:17-26"
                },
                {
                    day: 3,
                    type: "law-and-prophets",
                    verse: "Jer 5-6"
                },
                {
                    day: 4,
                    type: "gospels",
                    verse: "John 1:35-42"
                },
                {
                    day: 4,
                    type: "epistles",
                    verse: "Jas 2:1-13"
                },
                {
                    day: 4,
                    type: "wisdom",
                    verse: "Eccl 3:1-15"
                },
                {
                    day: 4,
                    type: "law-and-prophets",
                    verse: "Jer 7-9"
                },
                {
                    day: 5,
                    type: "gospels",
                    verse: "John 1:43-51"
                },
                {
                    day: 5,
                    type: "epistles",
                    verse: "Jas 2:14-26"
                },
                {
                    day: 5,
                    type: "wisdom",
                    verse: "Eccl 3:16-22"
                },
                {
                    day: 5,
                    type: "law-and-prophets",
                    verse: "Jer 10-11"
                },
                {
                    day: 6,
                    type: "gospels",
                    verse: "John 2:1-11"
                },
                {
                    day: 6,
                    type: "epistles",
                    verse: "Jas 3:1-12"
                },
                {
                    day: 6,
                    type: "wisdom",
                    verse: "Eccl 4"
                },
                {
                    day: 6,
                    type: "law-and-prophets",
                    verse: "Jer 12-13"
                },
                {
                    day: 7,
                    type: "gospels",
                    verse: "John 2:12-25"
                },
                {
                    day: 7,
                    type: "epistles",
                    verse: "Jas 3:13-18"
                },
                {
                    day: 7,
                    type: "wisdom",
                    verse: "Eccl 5"
                },
                {
                    day: 7,
                    type: "law-and-prophets",
                    verse: "Jer 14-15"
                },
                {
                    day: 8,
                    type: "gospels",
                    verse: "John 3:1-15"
                },
                {
                    day: 8,
                    type: "epistles",
                    verse: "Jas 4:1-10"
                },
                {
                    day: 8,
                    type: "wisdom",
                    verse: "Eccl 6"
                },
                {
                    day: 8,
                    type: "law-and-prophets",
                    verse: "Jer 16-18"
                },
                {
                    day: 9,
                    type: "gospels",
                    verse: "John 3:16-21"
                },
                {
                    day: 9,
                    type: "epistles",
                    verse: "Jas 4:11-17"
                },
                {
                    day: 9,
                    type: "wisdom",
                    verse: "Eccl 7:1-14"
                },
                {
                    day: 9,
                    type: "law-and-prophets",
                    verse: "Jer 19-22"
                },
                {
                    day: 10,
                    type: "gospels",
                    verse: "John 3:22-36"
                },
                {
                    day: 10,
                    type: "epistles",
                    verse: "Jas 5:1-6"
                },
                {
                    day: 10,
                    type: "wisdom",
                    verse: "Eccl 7:15-29"
                },
                {
                    day: 10,
                    type: "law-and-prophets",
                    verse: "Jer 23-25"
                },
                {
                    day: 11,
                    type: "gospels",
                    verse: "John 4:1-14"
                },
                {
                    day: 11,
                    type: "epistles",
                    verse: "Jas 5:7-12"
                },
                {
                    day: 11,
                    type: "wisdom",
                    verse: "Eccl 8"
                },
                {
                    day: 11,
                    type: "law-and-prophets",
                    verse: "Jer 26-29"
                },
                {
                    day: 12,
                    type: "gospels",
                    verse: "John 4:15-26"
                },
                {
                    day: 12,
                    type: "epistles",
                    verse: "Jas 5:13-20"
                },
                {
                    day: 12,
                    type: "wisdom",
                    verse: "Eccl 9"
                },
                {
                    day: 12,
                    type: "law-and-prophets",
                    verse: "Jer 30-31"
                },
                {
                    day: 13,
                    type: "gospels",
                    verse: "John 4:27-42"
                },
                {
                    day: 13,
                    type: "epistles",
                    verse: "1Pet 1:1-9"
                },
                {
                    day: 13,
                    type: "wisdom",
                    verse: "Eccl 10"
                },
                {
                    day: 13,
                    type: "law-and-prophets",
                    verse: "Jer 32-34"
                },
                {
                    day: 14,
                    type: "gospels",
                    verse: "John 4:43-54"
                },
                {
                    day: 14,
                    type: "epistles",
                    verse: "1Pet 1:10-16"
                },
                {
                    day: 14,
                    type: "wisdom",
                    verse: "Eccl 11"
                },
                {
                    day: 14,
                    type: "law-and-prophets",
                    verse: "Jer 35-38"
                },
                {
                    day: 15,
                    type: "gospels",
                    verse: "John 5:1-15"
                },
                {
                    day: 15,
                    type: "epistles",
                    verse: "1Pet 1:17-25"
                },
                {
                    day: 15,
                    type: "wisdom",
                    verse: "Eccl 12"
                },
                {
                    day: 15,
                    type: "law-and-prophets",
                    verse: "Jer 39-43"
                },
                {
                    day: 16,
                    type: "gospels",
                    verse: "John 5:16-30"
                },
                {
                    day: 16,
                    type: "epistles",
                    verse: "1Pet 2:1-8"
                },
                {
                    day: 16,
                    type: "wisdom",
                    verse: "Song 1"
                },
                {
                    day: 16,
                    type: "law-and-prophets",
                    verse: "Jer 44-46"
                },
                {
                    day: 17,
                    type: "gospels",
                    verse: "John 5:31-47"
                },
                {
                    day: 17,
                    type: "epistles",
                    verse: "1Pet 2:9-17"
                },
                {
                    day: 17,
                    type: "wisdom",
                    verse: "Song 2"
                },
                {
                    day: 17,
                    type: "law-and-prophets",
                    verse: "Jer 47-48"
                },
                {
                    day: 18,
                    type: "gospels",
                    verse: "John 6:1-15"
                },
                {
                    day: 18,
                    type: "epistles",
                    verse: "1Pet 2:18-25"
                },
                {
                    day: 18,
                    type: "wisdom",
                    verse: "Song 3"
                },
                {
                    day: 18,
                    type: "law-and-prophets",
                    verse: "Jer 49"
                },
                {
                    day: 19,
                    type: "gospels",
                    verse: "John 6:16-24"
                },
                {
                    day: 19,
                    type: "epistles",
                    verse: "1Pet 3:1-7"
                },
                {
                    day: 19,
                    type: "wisdom",
                    verse: "Song 4:1-7"
                },
                {
                    day: 19,
                    type: "law-and-prophets",
                    verse: "Jer 50"
                },
                {
                    day: 20,
                    type: "gospels",
                    verse: "John 6:25-40"
                },
                {
                    day: 20,
                    type: "epistles",
                    verse: "1Pet 3:8-12"
                },
                {
                    day: 20,
                    type: "wisdom",
                    verse: "Song 4:8-16"
                },
                {
                    day: 20,
                    type: "law-and-prophets",
                    verse: "Jer 51"
                },
                {
                    day: 21,
                    type: "gospels",
                    verse: "John 6:41-59"
                },
                {
                    day: 21,
                    type: "epistles",
                    verse: "1Pet 3:13-22"
                },
                {
                    day: 21,
                    type: "wisdom",
                    verse: "Song 5"
                },
                {
                    day: 21,
                    type: "law-and-prophets",
                    verse: "Jer 52"
                },
                {
                    day: 22,
                    type: "gospels",
                    verse: "John 6:60-71"
                },
                {
                    day: 22,
                    type: "epistles",
                    verse: "1Pet 4:1-11"
                },
                {
                    day: 22,
                    type: "wisdom",
                    verse: "Song 6"
                },
                {
                    day: 22,
                    type: "law-and-prophets",
                    verse: "LAMENTATIONS 1"
                },
                {
                    day: 23,
                    type: "gospels",
                    verse: "John 7:1-13"
                },
                {
                    day: 23,
                    type: "epistles",
                    verse: "1Pet 4:12-19"
                },
                {
                    day: 23,
                    type: "wisdom",
                    verse: "Song 7"
                },
                {
                    day: 23,
                    type: "law-and-prophets",
                    verse: "LAMENTATIONS 2"
                },
                {
                    day: 24,
                    type: "gospels",
                    verse: "John 7:14-24"
                },
                {
                    day: 24,
                    type: "epistles",
                    verse: "1Pet 5:1-7"
                },
                {
                    day: 24,
                    type: "wisdom",
                    verse: "Song 8:1-7"
                },
                {
                    day: 24,
                    type: "law-and-prophets",
                    verse: "LAMENTATIONS 3"
                },
                {
                    day: 25,
                    type: "gospels",
                    verse: "John 7:25-36"
                },
                {
                    day: 25,
                    type: "epistles",
                    verse: "1Pet 5:8-14"
                },
                {
                    day: 25,
                    type: "wisdom",
                    verse: "Song 8:8-14"
                },
                {
                    day: 25,
                    type: "law-and-prophets",
                    verse: "LAMENTATIONS 4-5"
                }
            ]
        },
        {
            monthNum: 11,
            monthName: "NOVEMBER",
            readings: [
                {
                    day: 1,
                    type: "gospels",
                    verse: "John 7:37-44"
                },
                {
                    day: 1,
                    type: "epistles",
                    verse: "2Pet 1:1-11"
                },
                {
                    day: 1,
                    type: "wisdom",
                    verse: "Job 1"
                },
                {
                    day: 1,
                    type: "law-and-prophets",
                    verse: "Ezek 1-3"
                },
                {
                    day: 2,
                    type: "gospels",
                    verse: "John 7:45-53"
                },
                {
                    day: 2,
                    type: "epistles",
                    verse: "2Pet 1:12-21"
                },
                {
                    day: 2,
                    type: "wisdom",
                    verse: "Job 2"
                },
                {
                    day: 2,
                    type: "law-and-prophets",
                    verse: "Ezek 4-8"
                },
                {
                    day: 3,
                    type: "gospels",
                    verse: "John 8:1-11"
                },
                {
                    day: 3,
                    type: "epistles",
                    verse: "2Pet 2:1-9"
                },
                {
                    day: 3,
                    type: "wisdom",
                    verse: "Job 3"
                },
                {
                    day: 3,
                    type: "law-and-prophets",
                    verse: "Ezek 9-12"
                },
                {
                    day: 4,
                    type: "gospels",
                    verse: "John 8:12-20"
                },
                {
                    day: 4,
                    type: "epistles",
                    verse: "2Pet 2:10-16"
                },
                {
                    day: 4,
                    type: "wisdom",
                    verse: "Job 4"
                },
                {
                    day: 4,
                    type: "law-and-prophets",
                    verse: "Ezek 13-15"
                },
                {
                    day: 5,
                    type: "gospels",
                    verse: "John 8:21-30"
                },
                {
                    day: 5,
                    type: "epistles",
                    verse: "2Pet 2:17-22"
                },
                {
                    day: 5,
                    type: "wisdom",
                    verse: "Job 5"
                },
                {
                    day: 5,
                    type: "law-and-prophets",
                    verse: "Ezek 16"
                },
                {
                    day: 6,
                    type: "gospels",
                    verse: "John 8:31-47"
                },
                {
                    day: 6,
                    type: "epistles",
                    verse: "2Pet 3:1-9"
                },
                {
                    day: 6,
                    type: "wisdom",
                    verse: "Job 6"
                },
                {
                    day: 6,
                    type: "law-and-prophets",
                    verse: "Ezek 17-19"
                },
                {
                    day: 7,
                    type: "gospels",
                    verse: "John 8:48-59"
                },
                {
                    day: 7,
                    type: "epistles",
                    verse: "2Pet 3:10-18"
                },
                {
                    day: 7,
                    type: "wisdom",
                    verse: "Job 7"
                },
                {
                    day: 7,
                    type: "law-and-prophets",
                    verse: "Ezek 20-21"
                },
                {
                    day: 8,
                    type: "gospels",
                    verse: "John 9:1-12"
                },
                {
                    day: 8,
                    type: "epistles",
                    verse: "1John 1:1-4"
                },
                {
                    day: 8,
                    type: "wisdom",
                    verse: "Job 8"
                },
                {
                    day: 8,
                    type: "law-and-prophets",
                    verse: "Ezek 22-23"
                },
                {
                    day: 9,
                    type: "gospels",
                    verse: "John 9:13-25"
                },
                {
                    day: 9,
                    type: "epistles",
                    verse: "1John 1:5-10"
                },
                {
                    day: 9,
                    type: "wisdom",
                    verse: "Job 9:1-20"
                },
                {
                    day: 9,
                    type: "law-and-prophets",
                    verse: "Ezek 24-26"
                },
                {
                    day: 10,
                    type: "gospels",
                    verse: "John 9:26-41"
                },
                {
                    day: 10,
                    type: "epistles",
                    verse: "1John 2:1-11"
                },
                {
                    day: 10,
                    type: "wisdom",
                    verse: "Job 9:21-35"
                },
                {
                    day: 10,
                    type: "law-and-prophets",
                    verse: "Ezek 27-28"
                },
                {
                    day: 11,
                    type: "gospels",
                    verse: "John 10:1-10"
                },
                {
                    day: 11,
                    type: "epistles",
                    verse: "1John 2:12-17"
                },
                {
                    day: 11,
                    type: "wisdom",
                    verse: "Job 10"
                },
                {
                    day: 11,
                    type: "law-and-prophets",
                    verse: "Ezek 29-30"
                },
                {
                    day: 12,
                    type: "gospels",
                    verse: "John 10:11-21"
                },
                {
                    day: 12,
                    type: "epistles",
                    verse: "1John 2:18-23"
                },
                {
                    day: 12,
                    type: "wisdom",
                    verse: "Job 11"
                },
                {
                    day: 12,
                    type: "law-and-prophets",
                    verse: "Ezek 31-32"
                },
                {
                    day: 13,
                    type: "gospels",
                    verse: "John 10:22-42"
                },
                {
                    day: 13,
                    type: "epistles",
                    verse: "1John 2:24-29"
                },
                {
                    day: 13,
                    type: "wisdom",
                    verse: "Job 12"
                },
                {
                    day: 13,
                    type: "law-and-prophets",
                    verse: "Ezek 33-34"
                },
                {
                    day: 14,
                    type: "gospels",
                    verse: "John 11:1-16"
                },
                {
                    day: 14,
                    type: "epistles",
                    verse: "1John 3:1-10"
                },
                {
                    day: 14,
                    type: "wisdom",
                    verse: "Job 13"
                },
                {
                    day: 14,
                    type: "law-and-prophets",
                    verse: "Ezek 35-37"
                },
                {
                    day: 15,
                    type: "gospels",
                    verse: "John 11:17-37"
                },
                {
                    day: 15,
                    type: "epistles",
                    verse: "1John 3:11-18"
                },
                {
                    day: 15,
                    type: "wisdom",
                    verse: "Job 14"
                },
                {
                    day: 15,
                    type: "law-and-prophets",
                    verse: "Ezek 38-39"
                },
                {
                    day: 16,
                    type: "gospels",
                    verse: "John 11:38-44"
                },
                {
                    day: 16,
                    type: "epistles",
                    verse: "1John 3:19-24"
                },
                {
                    day: 16,
                    type: "wisdom",
                    verse: "Job 15:1-16"
                },
                {
                    day: 16,
                    type: "law-and-prophets",
                    verse: "Ezek 40-41"
                },
                {
                    day: 17,
                    type: "gospels",
                    verse: "John 11:45-57"
                },
                {
                    day: 17,
                    type: "epistles",
                    verse: "1John 4:1-6"
                },
                {
                    day: 17,
                    type: "wisdom",
                    verse: "Job 15:17-35"
                },
                {
                    day: 17,
                    type: "law-and-prophets",
                    verse: "Ezek 42-44"
                },
                {
                    day: 18,
                    type: "gospels",
                    verse: "John 12:1-11"
                },
                {
                    day: 18,
                    type: "epistles",
                    verse: "1John 4:7-21"
                },
                {
                    day: 18,
                    type: "wisdom",
                    verse: "Job 16"
                },
                {
                    day: 18,
                    type: "law-and-prophets",
                    verse: "Ezek 45-47"
                },
                {
                    day: 19,
                    type: "gospels",
                    verse: "John 12:12-19"
                },
                {
                    day: 19,
                    type: "epistles",
                    verse: "1John 5:1-12"
                },
                {
                    day: 19,
                    type: "wisdom",
                    verse: "Job 17"
                },
                {
                    day: 19,
                    type: "law-and-prophets",
                    verse: "Ezek 48"
                },
                {
                    day: 20,
                    type: "gospels",
                    verse: "John 12:20-36"
                },
                {
                    day: 20,
                    type: "epistles",
                    verse: "1John 5:13-21"
                },
                {
                    day: 20,
                    type: "wisdom",
                    verse: "Job 18"
                },
                {
                    day: 20,
                    type: "law-and-prophets",
                    verse: "Dan 1-2"
                },
                {
                    day: 21,
                    type: "gospels",
                    verse: "John 12:37-50"
                },
                {
                    day: 21,
                    type: "epistles",
                    verse: "2John 1-13"
                },
                {
                    day: 21,
                    type: "wisdom",
                    verse: "Job 19"
                },
                {
                    day: 21,
                    type: "law-and-prophets",
                    verse: "Dan 3-4"
                },
                {
                    day: 22,
                    type: "gospels",
                    verse: "John 13:1-11"
                },
                {
                    day: 22,
                    type: "epistles",
                    verse: "3John 1-14"
                },
                {
                    day: 22,
                    type: "wisdom",
                    verse: "Job 20"
                },
                {
                    day: 22,
                    type: "law-and-prophets",
                    verse: "Dan 5-6"
                },
                {
                    day: 23,
                    type: "gospels",
                    verse: "John 13:12-17"
                },
                {
                    day: 23,
                    type: "epistles",
                    verse: "Jude 1-7"
                },
                {
                    day: 23,
                    type: "wisdom",
                    verse: "Job 21:1-21"
                },
                {
                    day: 23,
                    type: "law-and-prophets",
                    verse: "Dan 7-8"
                },
                {
                    day: 24,
                    type: "gospels",
                    verse: "John 13:18-30"
                },
                {
                    day: 24,
                    type: "epistles",
                    verse: "Jude 8-16"
                },
                {
                    day: 24,
                    type: "wisdom",
                    verse: "Job 21:22-34"
                },
                {
                    day: 24,
                    type: "law-and-prophets",
                    verse: "Dan 9"
                },
                {
                    day: 25,
                    type: "gospels",
                    verse: "John 13:31-38"
                },
                {
                    day: 25,
                    type: "epistles",
                    verse: "Jude 17-25"
                },
                {
                    day: 25,
                    type: "wisdom",
                    verse: "Job 22"
                },
                {
                    day: 25,
                    type: "law-and-prophets",
                    verse: "Dan 10-12"
                }
            ]
        },
        {
            monthNum: 12,
            monthName: "DECEMBER",
            readings: [
                {
                    day: 1,
                    type: "gospels",
                    verse: "John 14:1-14"
                },
                {
                    day: 1,
                    type: "epistles",
                    verse: "Rev 1:1-8"
                },
                {
                    day: 1,
                    type: "wisdom",
                    verse: "Job 23"
                },
                {
                    day: 1,
                    type: "law-and-prophets",
                    verse: "Hos 1-3"
                },
                {
                    day: 2,
                    type: "gospels",
                    verse: "John 14:15-21"
                },
                {
                    day: 2,
                    type: "epistles",
                    verse: "Rev 1:9-20"
                },
                {
                    day: 2,
                    type: "wisdom",
                    verse: "Job 24"
                },
                {
                    day: 2,
                    type: "law-and-prophets",
                    verse: "Hos 4-6"
                },
                {
                    day: 3,
                    type: "gospels",
                    verse: "John 14:22-31"
                },
                {
                    day: 3,
                    type: "epistles",
                    verse: "Rev 2:1-17"
                },
                {
                    day: 3,
                    type: "wisdom",
                    verse: "Job 25-26"
                },
                {
                    day: 3,
                    type: "law-and-prophets",
                    verse: "Hos 7-8"
                },
                {
                    day: 4,
                    type: "gospels",
                    verse: "John 15:1-8"
                },
                {
                    day: 4,
                    type: "epistles",
                    verse: "Rev 2:18-29"
                },
                {
                    day: 4,
                    type: "wisdom",
                    verse: "Job 27"
                },
                {
                    day: 4,
                    type: "law-and-prophets",
                    verse: "Hos 9-12"
                },
                {
                    day: 5,
                    type: "gospels",
                    verse: "John 15:9-17"
                },
                {
                    day: 5,
                    type: "epistles",
                    verse: "Rev 3:1-13"
                },
                {
                    day: 5,
                    type: "wisdom",
                    verse: "Job 28"
                },
                {
                    day: 5,
                    type: "law-and-prophets",
                    verse: "Hos 13-14"
                },
                {
                    day: 6,
                    type: "gospels",
                    verse: "John 15:18-27"
                },
                {
                    day: 6,
                    type: "epistles",
                    verse: "Rev 3:14-22"
                },
                {
                    day: 6,
                    type: "wisdom",
                    verse: "Job 29"
                },
                {
                    day: 6,
                    type: "law-and-prophets",
                    verse: "Joel 1"
                },
                {
                    day: 7,
                    type: "gospels",
                    verse: "John 16:1-11"
                },
                {
                    day: 7,
                    type: "epistles",
                    verse: "Rev 4"
                },
                {
                    day: 7,
                    type: "wisdom",
                    verse: "Job 30"
                },
                {
                    day: 7,
                    type: "law-and-prophets",
                    verse: "Joel 2-3"
                },
                {
                    day: 8,
                    type: "gospels",
                    verse: "John 16:12-24"
                },
                {
                    day: 8,
                    type: "epistles",
                    verse: "Rev 5"
                },
                {
                    day: 8,
                    type: "wisdom",
                    verse: "Job 31:1-23"
                },
                {
                    day: 8,
                    type: "law-and-prophets",
                    verse: "Amos 1-2"
                },
                {
                    day: 9,
                    type: "gospels",
                    verse: "John 16:25-33"
                },
                {
                    day: 9,
                    type: "epistles",
                    verse: "Rev 6"
                },
                {
                    day: 9,
                    type: "wisdom",
                    verse: "Job 31:24-40"
                },
                {
                    day: 9,
                    type: "law-and-prophets",
                    verse: "Amos 3-4"
                },
                {
                    day: 10,
                    type: "gospels",
                    verse: "John 17:1-5"
                },
                {
                    day: 10,
                    type: "epistles",
                    verse: "Rev 7"
                },
                {
                    day: 10,
                    type: "wisdom",
                    verse: "Job 32"
                },
                {
                    day: 10,
                    type: "law-and-prophets",
                    verse: "Amos 5-6"
                },
                {
                    day: 11,
                    type: "gospels",
                    verse: "John 17:6-19"
                },
                {
                    day: 11,
                    type: "epistles",
                    verse: "Rev 8"
                },
                {
                    day: 11,
                    type: "wisdom",
                    verse: "Job 33:1-11"
                },
                {
                    day: 11,
                    type: "law-and-prophets",
                    verse: "Amos 7-9"
                },
                {
                    day: 12,
                    type: "gospels",
                    verse: "John 17:20-26"
                },
                {
                    day: 12,
                    type: "epistles",
                    verse: "Rev 9"
                },
                {
                    day: 12,
                    type: "wisdom",
                    verse: "Job 33:12-33"
                },
                {
                    day: 12,
                    type: "law-and-prophets",
                    verse: "Obad 1-21"
                },
                {
                    day: 13,
                    type: "gospels",
                    verse: "John 18:1-18"
                },
                {
                    day: 13,
                    type: "epistles",
                    verse: "Rev 10"
                },
                {
                    day: 13,
                    type: "wisdom",
                    verse: "Job 34:1-20"
                },
                {
                    day: 13,
                    type: "law-and-prophets",
                    verse: "Jonah 1-4"
                },
                {
                    day: 14,
                    type: "gospels",
                    verse: "John 18:19-27"
                },
                {
                    day: 14,
                    type: "epistles",
                    verse: "Rev 11"
                },
                {
                    day: 14,
                    type: "wisdom",
                    verse: "Job 34:21-37"
                },
                {
                    day: 14,
                    type: "law-and-prophets",
                    verse: "Mic 1-3"
                },
                {
                    day: 15,
                    type: "gospels",
                    verse: "John 18:28-40"
                },
                {
                    day: 15,
                    type: "epistles",
                    verse: "Rev 12"
                },
                {
                    day: 15,
                    type: "wisdom",
                    verse: "Job 35"
                },
                {
                    day: 15,
                    type: "law-and-prophets",
                    verse: "Mic 4-5"
                },
                {
                    day: 16,
                    type: "gospels",
                    verse: "John 19:1-16"
                },
                {
                    day: 16,
                    type: "epistles",
                    verse: "Rev 13"
                },
                {
                    day: 16,
                    type: "wisdom",
                    verse: "Job 36:1-15"
                },
                {
                    day: 16,
                    type: "law-and-prophets",
                    verse: "Mic 6-7"
                },
                {
                    day: 17,
                    type: "gospels",
                    verse: "John 19:17-27"
                },
                {
                    day: 17,
                    type: "epistles",
                    verse: "Rev 14"
                },
                {
                    day: 17,
                    type: "wisdom",
                    verse: "Job 36:16-33"
                },
                {
                    day: 17,
                    type: "law-and-prophets",
                    verse: "Nah 1-3"
                },
                {
                    day: 18,
                    type: "gospels",
                    verse: "John 19:28-37"
                },
                {
                    day: 18,
                    type: "epistles",
                    verse: "Rev 15"
                },
                {
                    day: 18,
                    type: "wisdom",
                    verse: "Job 37"
                },
                {
                    day: 18,
                    type: "law-and-prophets",
                    verse: "Hab 1-3"
                },
                {
                    day: 19,
                    type: "gospels",
                    verse: "John 19:38-42"
                },
                {
                    day: 19,
                    type: "epistles",
                    verse: "Rev 16"
                },
                {
                    day: 19,
                    type: "wisdom",
                    verse: "Job 38:1-21"
                },
                {
                    day: 19,
                    type: "law-and-prophets",
                    verse: "Zeph 1-2"
                },
                {
                    day: 20,
                    type: "gospels",
                    verse: "John 20:1-9"
                },
                {
                    day: 20,
                    type: "epistles",
                    verse: "Rev 17"
                },
                {
                    day: 20,
                    type: "wisdom",
                    verse: "Job 38:22-41"
                },
                {
                    day: 20,
                    type: "law-and-prophets",
                    verse: "Zeph 3"
                },
                {
                    day: 21,
                    type: "gospels",
                    verse: "John 20:10-18"
                },
                {
                    day: 21,
                    type: "epistles",
                    verse: "Rev 18"
                },
                {
                    day: 21,
                    type: "wisdom",
                    verse: "Job 39"
                },
                {
                    day: 21,
                    type: "law-and-prophets",
                    verse: "Hag 1-2"
                },
                {
                    day: 22,
                    type: "gospels",
                    verse: "John 20:19-23"
                },
                {
                    day: 22,
                    type: "epistles",
                    verse: "Rev 19"
                },
                {
                    day: 22,
                    type: "wisdom",
                    verse: "Job 40"
                },
                {
                    day: 22,
                    type: "law-and-prophets",
                    verse: "Zech 1-5"
                },
                {
                    day: 23,
                    type: "gospels",
                    verse: "John 20:24-31"
                },
                {
                    day: 23,
                    type: "epistles",
                    verse: "Rev 20"
                },
                {
                    day: 23,
                    type: "wisdom",
                    verse: "Job 41:1-11"
                },
                {
                    day: 23,
                    type: "law-and-prophets",
                    verse: "Zech 6-9"
                },
                {
                    day: 24,
                    type: "gospels",
                    verse: "John 21:1-14"
                },
                {
                    day: 24,
                    type: "epistles",
                    verse: "Rev 21"
                },
                {
                    day: 24,
                    type: "wisdom",
                    verse: "Job 41:12-34"
                },
                {
                    day: 24,
                    type: "law-and-prophets",
                    verse: "Zech 10-14"
                },
                {
                    day: 25,
                    type: "gospels",
                    verse: "John 21:15-25"
                },
                {
                    day: 25,
                    type: "epistles",
                    verse: "Rev 22"
                },
                {
                    day: 25,
                    type: "wisdom",
                    verse: "Job 42"
                },
                {
                    day: 25,
                    type: "law-and-prophets",
                    verse: "MALACHI 1-4"
                }
            ]
        }
    ]
}